
export const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 460.775 460.775"
    style={{
      enableBackground: "new 0 0 460.775 460.775",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M285.08 230.397 456.218 59.27c6.076-6.077 6.076-15.911 0-21.986L423.511 4.565a15.55 15.55 0 0 0-21.985 0l-171.138 171.14L59.25 4.565a15.551 15.551 0 0 0-21.985 0L4.558 37.284c-6.077 6.075-6.077 15.909 0 21.986l171.138 171.128L4.575 401.505c-6.074 6.077-6.074 15.911 0 21.986l32.709 32.719a15.555 15.555 0 0 0 21.986 0l171.117-171.12 171.118 171.12a15.551 15.551 0 0 0 21.985 0l32.709-32.719c6.074-6.075 6.074-15.909 0-21.986L285.08 230.397z" />
  </svg>
)

export const GitBranchIcon = ({
  size = 16,
  color = "#585C68",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 3v12" />
    <circle cx="6" cy="18" r="3" />
    <path d="M18 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
    <path d="M18 9v3a3 3 0 0 1-3 3H9" />
  </svg>
);

export const BagelAIStarIcon = ({ size = 14, color = "#5C5CEB" }) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 11C2 6.58172 5.58172 3 10 3C14.4183 3 18 6.58172 18 11C18 15.4183 14.4183 19 10 19C5.58172 19 2 15.4183 2 11ZM10 8.33333C8.52724 8.33333 7.33333 9.52724 7.33333 11C7.33333 12.4728 8.52724 13.6667 10 13.6667C11.4728 13.6667 12.6667 12.4728 12.6667 11C12.6667 9.52724 11.4728 8.33333 10 8.33333Z" fill="#FF8700"/>
    <path d="M15.6016 0.509766C15.7986 0.546969 15.9577 0.689726 16.0186 0.876953L16.04 0.973633L16.0703 1.16699C16.4182 3.14578 18.0206 4.69416 20.0264 4.95996C20.2932 4.99547 20.5 5.22258 20.5 5.5C20.5 5.77748 20.2933 6.00556 20.0264 6.04102C17.9558 6.3154 16.3146 7.95586 16.04 10.0264C16.0045 10.2932 15.7773 10.4999 15.5 10.5C15.2225 10.5 14.9945 10.2933 14.959 10.0264C14.6845 7.95605 13.0439 6.31562 10.9736 6.04102C10.7401 6.00996 10.553 5.83145 10.5098 5.60156L10.5 5.5L10.5098 5.39844C10.5531 5.16865 10.7402 4.99105 10.9736 4.95996L11.167 4.92969C13.1456 4.58172 14.6931 2.97921 14.959 0.973633L14.9814 0.876953C15.0525 0.65845 15.2571 0.5 15.5 0.5L15.6016 0.509766Z" fill="#5C5CEB" stroke="white"/>
  </svg>
);

// Custom Star Icon component matching the SVG design
export const CustomStarIcon = ({ size = 14, color = "#5C5CEB" }) => (
  
  <svg width={size} height={size} viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5.00007C0 4.97732 0.0170664 4.95814 0.0396165 4.95515C2.33395 4.65083 4.1507 2.83396 4.45486 0.539574C4.45784 0.517049 4.477 0.5 4.49972 0.5C4.52245 0.5 4.54161 0.517049 4.54459 0.539574C4.84877 2.83416 6.66583 4.65115 8.96045 4.95523C8.98296 4.95821 9 4.97736 9 5.00007C9 5.02278 8.98296 5.04192 8.96045 5.0449C6.66588 5.34897 4.84885 7.16589 4.54461 9.46041C4.54162 9.48294 4.52246 9.5 4.49972 9.5C4.47699 9.5 4.45783 9.48294 4.45484 9.46041C4.15063 7.1661 2.3339 5.3493 0.0396164 5.04499C0.0170663 5.042 0 5.02282 0 5.00007Z" fill="#5C5CEB"/>
  </svg>
);

export const EmptyIcon = (props) => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26 25C26 22.7909 27.7909 21 30 21H39C41.2091 21 43 22.7909 43 25V34C43 36.2091 41.2091 38 39 38H30C27.7909 38 26 36.2091 26 34V25Z" fill="#DADAF3"/>
    <path d="M26 56C26 53.7909 27.7909 52 30 52H39C41.2091 52 43 53.7909 43 56V65C43 67.2091 41.2091 69 39 69H30C27.7909 69 26 67.2091 26 65V56Z" fill="#DADAF3"/>
    <rect x="48" y="23" width="45" height="4" rx="1" fill="#DADAF3"/>
    <rect x="48" y="54" width="45" height="4" rx="1" fill="#DADAF3"/>
    <rect x="48" y="30" width="36" height="4" rx="1" fill="#DADAF3"/>
    <path d="M69.9919 34H49C48.4477 34 48 33.5523 48 33V31C48 30.4477 48.4477 30 49 30H68.6739C69.1975 31.2935 69.639 32.629 69.9919 34Z" fill="#5C5CEB" fill-opacity="0.2"/>
    <rect x="48" y="61" width="36" height="4" rx="1" fill="#DADAF3"/>
    <path d="M64.7514 23C65.6864 24.2652 66.5304 25.6018 67.2738 27H49C48.4477 27 48 26.5523 48 26V24C48 23.4477 48.4477 23 49 23H64.7514Z" fill="#5C5CEB" fill-opacity="0.2"/>
    <path d="M64.7514 61C63.6952 62.429 62.523 63.767 61.2486 65H49C48.4477 65 48 64.5523 48 64V62C48 61.4477 48.4477 61 49 61H64.7514Z" fill="#5C5CEB" fill-opacity="0.2"/>
    <path d="M68.6739 54C68.1137 55.3841 67.4594 56.7201 66.719 58H49C48.4477 58 48 57.5523 48 57V55C48 54.4477 48.4477 54 49 54H68.6739Z" fill="#5C5CEB" fill-opacity="0.2"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M72.0744 69.8317C77.6499 63.0867 81 54.4346 81 45C81 23.4609 63.5391 6 42 6C20.4609 6 3 23.4609 3 45C3 66.5391 20.4609 84 42 84C51.9445 84 61.0197 80.278 67.9084 74.1511L90.8787 97.1213C92.0502 98.2929 93.9497 98.2929 95.1213 97.1213C96.2929 95.9497 96.2929 94.0502 95.1213 92.8787L72.0744 69.8317ZM77 45C77 64.33 61.33 80 42 80C22.67 80 7 64.33 7 45C7 25.67 22.67 10 42 10C61.33 10 77 25.67 77 45Z" fill="#B6B6EE"/>
  </svg>
)
export const DomainHeaderIcon = ({ color = "#1C1B1F", fill = "#1C1B1F", size = 16, ...props }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    {...props}
  >
    <path 
      d="M7.50635 13.7199V8.28438L2.98733 5.62457V10.9264C2.98733 10.966 2.99707 11.0031 3.01655 11.0378C3.03602 11.0724 3.06522 11.1021 3.10417 11.1269L7.50635 13.7199ZM8.49365 13.7199L12.8958 11.1462C12.9348 11.1215 12.964 11.0917 12.9835 11.0571C13.0029 11.0224 13.0127 10.9853 13.0127 10.9457V5.64387L8.49365 8.28438V13.7199ZM8 7.40226L12.6519 4.68452L8.09786 2.0336C8.05891 2.00885 8.01996 1.99648 7.98101 1.99648C7.94206 1.99648 7.90311 2.00885 7.86416 2.0336L3.34807 4.68452L8 7.40226ZM2.61052 12.009C2.41841 11.8967 2.26863 11.7463 2.16118 11.5579C2.05373 11.3695 2 11.163 2 10.9383V5.04242C2 4.8177 2.05373 4.61115 2.16118 4.42278C2.26863 4.23441 2.41841 4.08403 2.61052 3.97167L7.37049 1.17078C7.56134 1.05693 7.77118 1 8 1C8.22882 1 8.43866 1.05693 8.62951 1.17078L13.3895 3.97167C13.5816 4.08403 13.7314 4.23441 13.8388 4.42278C13.9463 4.61115 14 4.8177 14 5.04242V10.9383C14 11.163 13.9463 11.3695 13.8388 11.5579C13.7314 11.7463 13.5816 11.8967 13.3895 12.009L8.61052 14.8292C8.41801 14.9431 8.21409 15 7.99875 15C7.78342 15 7.58033 14.9431 7.38948 14.8292L2.61052 12.009Z" 
      fill={fill}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>)

export const StatusHeaderIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.56667 14.0339C5.07778 13.7228 3.86111 12.9839 2.91667 11.8172C1.97222 10.6505 1.5 9.30609 1.5 7.78387C1.5 6.26165 1.97222 4.91443 2.91667 3.7422C3.86111 2.56998 5.07778 1.82832 6.56667 1.5172C6.75556 1.47276 6.92222 1.51443 7.06667 1.6422C7.21111 1.76998 7.28333 1.92832 7.28333 2.1172C7.28333 2.26165 7.24167 2.38665 7.15833 2.4922C7.075 2.59776 6.96111 2.6672 6.81667 2.70054C5.60556 2.95609 4.61667 3.55887 3.85 4.50887C3.08333 5.45887 2.7 6.55054 2.7 7.78387C2.7 9.0172 3.08333 10.1061 3.85 11.0505C4.61667 11.995 5.60556 12.595 6.81667 12.8505C6.96111 12.8839 7.075 12.9533 7.15833 13.0589C7.24167 13.1644 7.28333 13.2894 7.28333 13.4339C7.28333 13.6228 7.21111 13.7811 7.06667 13.9089C6.92222 14.0366 6.75556 14.0783 6.56667 14.0339ZM9.2 14.0339C9.01111 14.0783 8.84444 14.0366 8.7 13.9089C8.55556 13.7811 8.48333 13.6228 8.48333 13.4339C8.48333 13.2894 8.52778 13.1644 8.61667 13.0589C8.70556 12.9533 8.81667 12.8839 8.95 12.8505C9.27222 12.7839 9.58056 12.6894 9.875 12.5672C10.1694 12.445 10.45 12.295 10.7167 12.1172C10.8389 12.0394 10.9667 12.0089 11.1 12.0255C11.2333 12.0422 11.35 12.1005 11.45 12.2005C11.5944 12.345 11.6583 12.5117 11.6417 12.7005C11.625 12.8894 11.5389 13.0339 11.3833 13.1339C11.05 13.3561 10.7 13.5394 10.3333 13.6839C9.96667 13.8283 9.58889 13.945 9.2 14.0339ZM12.3167 11.3672C12.2167 11.2672 12.1556 11.1478 12.1333 11.0089C12.1111 10.87 12.1389 10.7394 12.2167 10.6172C12.3944 10.3505 12.5444 10.07 12.6667 9.77554C12.7889 9.48109 12.8833 9.17276 12.95 8.85054C12.9722 8.70609 13.0389 8.59221 13.15 8.50887C13.2611 8.42554 13.3889 8.38387 13.5333 8.38387C13.7222 8.38387 13.8806 8.45609 14.0083 8.60054C14.1361 8.74498 14.1778 8.91165 14.1333 9.10054C14.0444 9.48943 13.9278 9.8672 13.7833 10.2339C13.6389 10.6005 13.4556 10.9505 13.2333 11.2839C13.1333 11.4394 12.9889 11.5255 12.8 11.5422C12.6111 11.5589 12.45 11.5005 12.3167 11.3672ZM13.55 7.18387C13.4056 7.18387 13.2778 7.1422 13.1667 7.05887C13.0556 6.97554 12.9833 6.86165 12.95 6.7172C12.8833 6.39498 12.7917 6.08665 12.675 5.7922C12.5583 5.49776 12.4111 5.2172 12.2333 4.95054C12.1556 4.82832 12.125 4.69776 12.1417 4.55887C12.1583 4.41998 12.2167 4.30054 12.3167 4.20054C12.45 4.0672 12.6111 4.00887 12.8 4.02554C12.9889 4.0422 13.1333 4.12832 13.2333 4.28387C13.4556 4.6172 13.6389 4.9672 13.7833 5.33387C13.9278 5.70054 14.0444 6.07832 14.1333 6.4672C14.1778 6.65609 14.1389 6.82276 14.0167 6.9672C13.8944 7.11165 13.7389 7.18387 13.55 7.18387ZM10.7333 3.43387C10.4556 3.25609 10.1694 3.10609 9.875 2.98387C9.58056 2.86165 9.27222 2.7672 8.95 2.70054C8.80556 2.67832 8.69167 2.61165 8.60833 2.50054C8.525 2.38943 8.48333 2.26165 8.48333 2.1172C8.48333 1.92832 8.55556 1.76998 8.7 1.6422C8.84444 1.51443 9.01111 1.47276 9.2 1.5172C9.58889 1.60609 9.96667 1.72554 10.3333 1.87554C10.7 2.02554 11.05 2.21165 11.3833 2.43387C11.5389 2.53387 11.625 2.67832 11.6417 2.8672C11.6583 3.05609 11.6 3.2172 11.4667 3.35054C11.3667 3.45054 11.25 3.50887 11.1167 3.52554C10.9833 3.5422 10.8556 3.51165 10.7333 3.43387ZM7.93333 10.9672C7.76667 10.9672 7.625 10.9089 7.50833 10.7922C7.39167 10.6755 7.33333 10.5339 7.33333 10.3672V6.8672L6.01667 8.20054C5.89444 8.32276 5.75278 8.38387 5.59167 8.38387C5.43056 8.38387 5.28889 8.32276 5.16667 8.20054C5.04444 8.07832 4.98056 7.93665 4.975 7.77554C4.96944 7.61443 5.02778 7.47276 5.15 7.35054L7.51667 4.98387C7.63889 4.86165 7.77778 4.80054 7.93333 4.80054C8.08889 4.80054 8.22778 4.86165 8.35 4.98387L10.7167 7.35054C10.8389 7.47276 10.9 7.61443 10.9 7.77554C10.9 7.93665 10.8389 8.07832 10.7167 8.20054C10.5944 8.32276 10.4528 8.38387 10.2917 8.38387C10.1306 8.38387 9.98889 8.32276 9.86667 8.20054L8.53333 6.8672V10.3672C8.53333 10.5339 8.475 10.6755 8.35833 10.7922C8.24167 10.9089 8.1 10.9672 7.93333 10.9672Z" fill="#585C68"/>
  </svg>
)

export const PriorityHeaderIcon = (props) => (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.642857 8.5C0.460714 8.5 0.308036 8.43648 0.184822 8.30944C0.0616072 8.18241 0 8.025 0 7.83722C0 7.64945 0.0616072 7.49074 0.184822 7.36111C0.308036 7.23148 0.460714 7.16667 0.642857 7.16667H3.64286C3.825 7.16667 3.97768 7.23019 4.10089 7.35722C4.22411 7.48426 4.28571 7.64167 4.28571 7.82944C4.28571 8.01722 4.22411 8.17593 4.10089 8.30556C3.97768 8.43519 3.825 8.5 3.64286 8.5H0.642857ZM0.648036 5.16667C0.466012 5.16667 0.3125 5.10315 0.1875 4.97611C0.0625 4.84907 0 4.69167 0 4.50389C0 4.31611 0.0615476 4.15741 0.184643 4.02778C0.307738 3.89815 0.460298 3.83333 0.642321 3.83333H7.06625C7.24827 3.83333 7.40179 3.89685 7.52679 4.02389C7.65179 4.15093 7.71429 4.30833 7.71429 4.49611C7.71429 4.68389 7.65274 4.84259 7.52964 4.97222C7.40655 5.10185 7.25399 5.16667 7.07196 5.16667H0.648036ZM0.642857 1.83333C0.460714 1.83333 0.308036 1.76982 0.184822 1.64278C0.0616072 1.51574 0 1.35833 0 1.17056C0 0.982778 0.0616072 0.824074 0.184822 0.694444C0.308036 0.564815 0.460714 0.5 0.642857 0.5H11.3571C11.5393 0.5 11.692 0.563518 11.8152 0.690555C11.9384 0.817592 12 0.975 12 1.16278C12 1.35056 11.9384 1.50926 11.8152 1.63889C11.692 1.76852 11.5393 1.83333 11.3571 1.83333H0.642857Z" fill="#585C68"/>
  </svg>
)

export const OwnerHeaderIcon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.99984 5.74357C5.28109 5.74357 4.67088 5.49274 4.16921 4.99107C3.66741 4.48927 3.4165 3.87899 3.4165 3.16024C3.4165 2.44149 3.66741 1.83128 4.16921 1.32961C4.67088 0.827807 5.28109 0.576904 5.99984 0.576904C6.71859 0.576904 7.3288 0.827807 7.83046 1.32961C8.33227 1.83128 8.58317 2.44149 8.58317 3.16024C8.58317 3.87899 8.33227 4.48927 7.83046 4.99107C7.3288 5.49274 6.71859 5.74357 5.99984 5.74357ZM0.416504 10.3238V9.90378C0.416504 9.6485 0.492615 9.40253 0.644837 9.16586C0.79706 8.9292 1.00998 8.72433 1.28359 8.55128C2.00998 8.13364 2.77345 7.81343 3.574 7.59065C4.37456 7.36788 5.18171 7.25649 5.99546 7.25649C6.80921 7.25649 7.61782 7.36788 8.4213 7.59065C9.22477 7.81343 9.9897 8.13364 10.7161 8.55128C10.9897 8.71045 11.2026 8.91183 11.3548 9.15545C11.5071 9.39906 11.5832 9.6485 11.5832 9.90378V10.3238C11.5832 10.6293 11.4763 10.889 11.2625 11.1027C11.0487 11.3163 10.7888 11.4232 10.483 11.4232H1.51005C1.20407 11.4232 0.945323 11.3163 0.733795 11.1027C0.522268 10.889 0.416504 10.6293 0.416504 10.3238ZM1.49984 10.3398H10.4998V9.90378C10.4998 9.81586 10.4682 9.73316 10.4048 9.65565C10.3414 9.57815 10.2539 9.51239 10.1425 9.45836C9.5356 9.09086 8.87991 8.81253 8.17546 8.62336C7.47088 8.43434 6.74567 8.33982 5.99984 8.33982C5.254 8.33982 4.5288 8.43434 3.82421 8.62336C3.11977 8.81253 2.46407 9.09086 1.85713 9.45836C1.74505 9.53531 1.65748 9.60899 1.59442 9.6794C1.53137 9.74982 1.49984 9.82461 1.49984 9.90378V10.3398ZM6.00421 4.66024C6.41796 4.66024 6.77067 4.51295 7.06234 4.21836C7.354 3.92378 7.49984 3.56961 7.49984 3.15586C7.49984 2.74211 7.35255 2.3894 7.05796 2.09774C6.76338 1.80607 6.40921 1.66024 5.99546 1.66024C5.58171 1.66024 5.229 1.8076 4.93734 2.10232C4.64567 2.3969 4.49984 2.75107 4.49984 3.16482C4.49984 3.57843 4.64713 3.93107 4.94171 4.22274C5.2363 4.5144 5.59046 4.66024 6.00421 4.66024Z" fill="#585C68"/>
  </svg>
)

export const DeliveryHeaderIcon = (props) => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.7824 13.6834C11.2343 13.6834 10.757 13.5168 10.3505 13.1834C9.94399 12.8501 9.68301 12.4334 9.5676 11.9334H5.53239C4.82197 11.9334 4.22072 11.6875 3.72864 11.1955C3.2367 10.7034 2.99072 10.1022 2.99072 9.39176C2.99072 8.68135 3.2367 8.0801 3.72864 7.58801C4.22072 7.09607 4.82197 6.8501 5.53239 6.8501H8.03239C8.571 6.8501 9.03204 6.65767 9.41551 6.27281C9.79899 5.88808 9.99072 5.42551 9.99072 4.8851C9.99072 4.34468 9.79899 3.88426 9.41551 3.50385C9.03204 3.12357 8.571 2.93343 8.03239 2.93343H4.99718C4.88704 3.43343 4.62739 3.8501 4.21822 4.18343C3.80906 4.51676 3.33045 4.68343 2.78239 4.68343C2.14586 4.68343 1.60475 4.46072 1.15906 4.01531C0.7135 3.56989 0.490723 3.02906 0.490723 2.39281C0.490723 1.75642 0.7135 1.21524 1.15906 0.769264C1.60475 0.323153 2.14586 0.100098 2.78239 0.100098C3.33045 0.100098 3.80906 0.266764 4.21822 0.600098C4.62739 0.933431 4.88704 1.3501 4.99718 1.8501H8.03239C8.88169 1.8501 9.601 2.14468 10.1903 2.73385C10.7795 3.32315 11.0741 4.04246 11.0741 4.89176C11.0741 5.74107 10.7795 6.46038 10.1903 7.04968C9.601 7.63885 8.88169 7.93343 8.03239 7.93343H5.53239C5.13128 7.93343 4.78794 8.07677 4.50239 8.36343C4.21683 8.64996 4.07406 8.99447 4.07406 9.39697C4.07406 9.79947 4.21683 10.1423 4.50239 10.4255C4.78794 10.7086 5.13128 10.8501 5.53239 10.8501H9.5676C9.67774 10.3501 9.93739 9.93343 10.3466 9.6001C10.7557 9.26676 11.2343 9.1001 11.7824 9.1001C12.4189 9.1001 12.96 9.32281 13.4057 9.76822C13.8513 10.2136 14.0741 10.7545 14.0741 11.3907C14.0741 12.0271 13.8513 12.5683 13.4057 13.0143C12.96 13.4604 12.4189 13.6834 11.7824 13.6834ZM2.78239 3.6001C3.11919 3.6001 3.40475 3.48288 3.63906 3.24843C3.8735 3.01413 3.99072 2.72857 3.99072 2.39176C3.99072 2.05496 3.8735 1.7694 3.63906 1.5351C3.40475 1.30065 3.11919 1.18343 2.78239 1.18343C2.44558 1.18343 2.16003 1.30065 1.92572 1.5351C1.69128 1.7694 1.57406 2.05496 1.57406 2.39176C1.57406 2.72857 1.69128 3.01413 1.92572 3.24843C2.16003 3.48288 2.44558 3.6001 2.78239 3.6001Z" fill="#585C68"/>
  </svg>

)

export const ProductAreaHeaderIcon = (props) => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill={props.fill || "#585C68"} fillRule="evenodd" clipRule="evenodd" d="M0.610521 11.009C0.418406 10.8967 0.268627 10.7463 0.161184 10.5579C0.0537281 10.3695 0 10.163 0 9.93827V4.04242C0 3.8177 0.0537281 3.61115 0.161184 3.42278C0.268627 3.23441 0.418406 3.08403 0.610521 2.97167L5.37049 0.170784C5.56134 0.0569282 5.77118 0 6 0C6.22882 0 6.43866 0.0569282 6.62951 0.170784L11.3895 2.97167C11.5816 3.08403 11.7314 3.23441 11.8388 3.42278C11.9463 3.61115 12 3.8177 12 4.04242V9.93827C12 10.163 11.9463 10.3695 11.8388 10.5579C11.7314 10.7463 11.5816 10.8967 11.3895 11.009L6.61052 13.8292C6.41801 13.9431 6.21409 14 5.99875 14C5.78342 14 5.58033 13.9431 5.38948 13.8292L0.610521 11.009ZM5.50635 12.7199V9.95958C4.08437 9.72416 3 8.48871 3 7C3 6.62145 3.07011 6.25928 3.19806 5.92577L0.987326 4.62457V9.92638C0.987326 9.966 0.997066 10.0031 1.01655 10.0378C1.03602 10.0724 1.06522 10.1021 1.10417 10.1269L5.50635 12.7199ZM3.70858 5.06357C4.25888 4.41304 5.0812 4 6 4C6.9188 4 7.74112 4.41304 8.29142 5.06357L10.6519 3.68452L6.09786 1.0336C6.05891 1.00885 6.01996 0.996478 5.98101 0.996478C5.94206 0.996478 5.90311 1.00885 5.86416 1.0336L1.34807 3.68452L3.70858 5.06357ZM8.80502 5.93383C8.93101 6.26512 9 6.6245 9 7C9 8.48871 7.91563 9.72416 6.49365 9.95958V12.7199L10.8958 10.1462C10.9348 10.1215 10.964 10.0917 10.9835 10.0571C11.0029 10.0224 11.0127 9.9853 11.0127 9.94569V4.64387L8.80502 5.93383ZM8 7C8 8.10457 7.10457 9 6 9C4.89543 9 4 8.10457 4 7C4 5.89543 4.89543 5 6 5C7.10457 5 8 5.89543 8 7Z"/>
  </svg>
)

export const ProductAreaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#0A122E"
      d="m6.413 6.82 2.5-1.617a2 2 0 0 1 2.173 0l2.5 1.618A2 2 0 0 1 14.5 8.5v3a2 2 0 0 1-.914 1.68l-2.5 1.617a2 2 0 0 1-2.172 0l-2.5-1.618A2 2 0 0 1 5.5 11.5v-3a2 2 0 0 1 .913-1.68Z"
      opacity={0.1}
    />
    <path
      stroke="#0A122E"
      strokeWidth={1.4}
      d="m6.413 6.82 2.5-1.617a2 2 0 0 1 2.173 0l2.5 1.618A2 2 0 0 1 14.5 8.5v3a2 2 0 0 1-.914 1.68l-2.5 1.617a2 2 0 0 1-2.172 0l-2.5-1.618A2 2 0 0 1 5.5 11.5v-3a2 2 0 0 1 .913-1.68ZM10 15v-5m0 0 4-2.5M10 10 6 7.5"
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-7.461 8.867M17.287 15.282a8.998 8.998 0 0 0 1.382-2.865M15.569 17.07l.148-.119"
    />
  </svg>
)

export const RequestsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#a)"
    >
      <path
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="M18.333 8.333v2.5c0 3.334-1.666 5-5 5h-.416a.845.845 0 0 0-.667.334L11 17.833c-.55.734-1.45.734-2 0l-1.25-1.666c-.133-.184-.442-.334-.667-.334h-.416c-3.334 0-5-.833-5-5V6.667c0-3.334 1.666-5 5-5h5"
      />
      <path
        fill="#0A122E"
        strokeWidth={1.5}
        d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
        opacity={0.2}
      />
      <path
        strokeWidth={1.4}
        d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
      />
      <path
        strokeWidth={1.8}
        d="M13.33 9.167h.008M9.996 9.167h.008M6.662 9.167h.008"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const RequestsIconSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#a)"
    >
      <path
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="M18.333 8.333v2.5c0 3.334-1.666 5-5 5h-.416a.845.845 0 0 0-.667.334L11 17.833c-.55.734-1.45.734-2 0l-1.25-1.666c-.133-.184-.442-.334-.667-.334h-.416c-3.334 0-5-.833-5-5V6.667c0-3.334 1.666-5 5-5h5"
      />
      <path
        fill="#5C5CEB"
        strokeWidth={1.5}
        d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
        opacity={0.2}
      />
      <path
        strokeWidth={1.4}
        d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
      />
      <path
        strokeWidth={1.8}
        d="M13.33 9.167h.008M9.996 9.167h.008M6.662 9.167h.008"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);


export const IdeasIcon = ({ width = 20, height = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...props}
  >
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m18.05 8.7-.816 3.483c-.7 3.009-2.084 4.225-4.684 3.975a8.78 8.78 0 0 1-1.35-.225L9.8 15.6c-3.475-.825-4.55-2.542-3.733-6.025l.817-3.492c.166-.708.366-1.325.616-1.833.975-2.017 2.634-2.558 5.417-1.9l1.392.325c3.491.817 4.558 2.542 3.741 6.025Z"
    />
    <path
      fill="#0A122E"
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.317.434c-3.308 1.066-5.05.175-6.125-3.134l-1.066-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.316-.434c.342-.108.667-.2.975-.258-.25.508-.45 1.125-.616 1.833l-.817 3.492c-.817 3.483.258 5.2 3.733 6.025l1.4.333c.484.117.934.192 1.35.225Z"
      opacity={0.2}
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.316.434c-3.309 1.066-5.05.175-6.125-3.134l-1.067-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.317-.434c.341-.108.666-.2.975-.258-.25.508-.45 1.125-.617 1.833l-.817 3.492c-.816 3.483.259 5.2 3.734 6.025l1.4.333c.483.117.933.192 1.35.225ZM10.534 7.108l4.041 1.025M9.717 10.333l2.417.617"
    />
  </svg>
);

export const SmallIdeasIcon = ({ width = 14.6, height = 14.6, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m18.05 8.7-.816 3.483c-.7 3.009-2.084 4.225-4.684 3.975a8.78 8.78 0 0 1-1.35-.225L9.8 15.6c-3.475-.825-4.55-2.542-3.733-6.025l.817-3.492c.166-.708.366-1.325.616-1.833.975-2.017 2.634-2.558 5.417-1.9l1.392.325c3.491.817 4.558 2.542 3.741 6.025Z"
    />
    <path
      fill="#0A122E"
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.317.434c-3.308 1.066-5.05.175-6.125-3.134l-1.066-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.316-.434c.342-.108.667-.2.975-.258-.25.508-.45 1.125-.616 1.833l-.817 3.492c-.817 3.483.258 5.2 3.733 6.025l1.4.333c.484.117.934.192 1.35.225Z"
      opacity={0.2}
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.316.434c-3.309 1.066-5.05.175-6.125-3.134l-1.067-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.317-.434c.341-.108.666-.2.975-.258-.25.508-.45 1.125-.617 1.833l-.817 3.492c-.816 3.483.259 5.2 3.734 6.025l1.4.333c.483.117.933.192 1.35.225ZM10.534 7.108l4.041 1.025M9.717 10.333l2.417.617"
    />
  </svg>
);

export const IdeasIconCustomer = ({ width = 20, height = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      stroke={"#5C5CEB"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m18.05 8.7-.816 3.483c-.7 3.009-2.084 4.225-4.684 3.975a8.78 8.78 0 0 1-1.35-.225L9.8 15.6c-3.475-.825-4.55-2.542-3.733-6.025l.817-3.492c.166-.708.366-1.325.616-1.833.975-2.017 2.634-2.558 5.417-1.9l1.392.325c3.491.817 4.558 2.542 3.741 6.025Z"
    />
    <path
      fill={"#5C5CEB"}
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.317.434c-3.308 1.066-5.05.175-6.125-3.134l-1.066-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.316-.434c.342-.108.667-.2.975-.258-.25.508-.45 1.125-.616 1.833l-.817 3.492c-.817 3.483.258 5.2 3.733 6.025l1.4.333c.484.117.934.192 1.35.225Z"
      opacity={0.2}
    />
    <path
      stroke={"#5C5CEB"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.316.434c-3.309 1.066-5.05.175-6.125-3.134l-1.067-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.317-.434c.341-.108.666-.2.975-.258-.25.508-.45 1.125-.617 1.833l-.817 3.492c-.816 3.483.259 5.2 3.734 6.025l1.4.333c.483.117.933.192 1.35.225ZM10.534 7.108l4.041 1.025M9.717 10.333l2.417.617"
    />
  </svg>
);
export const IdeasIconSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m18.05 8.7-.816 3.483c-.7 3.009-2.084 4.225-4.684 3.975a8.78 8.78 0 0 1-1.35-.225L9.8 15.6c-3.475-.825-4.55-2.542-3.733-6.025l.817-3.492c.166-.708.366-1.325.616-1.833.975-2.017 2.634-2.558 5.417-1.9l1.392.325c3.491.817 4.558 2.542 3.741 6.025Z"
    />
    <path
      fill="#5C5CEB"
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.317.434c-3.308 1.066-5.05.175-6.125-3.134l-1.066-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.316-.434c.342-.108.667-.2.975-.258-.25.508-.45 1.125-.616 1.833l-.817 3.492c-.817 3.483.258 5.2 3.733 6.025l1.4.333c.484.117.934.192 1.35.225Z"
      opacity={0.2}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M12.55 16.158c-.516.35-1.166.642-1.958.9l-1.316.434c-3.309 1.066-5.05.175-6.125-3.134l-1.067-3.291C1.017 7.758 1.9 6.008 5.209 4.942l1.317-.434c.341-.108.666-.2.975-.258-.25.508-.45 1.125-.617 1.833l-.817 3.492c-.816 3.483.259 5.2 3.734 6.025l1.4.333c.483.117.933.192 1.35.225ZM10.534 7.108l4.041 1.025M9.717 10.333l2.417.617"
    />
  </svg>
);

export const FromBagelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a22)">
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.2}
        d="M14.875 4h2.25M16 2.875v2.25"
      />
      <circle cx={16} cy={4} r={3} fill="#5C5CEB" opacity={0.1} />
      <circle cx={16} cy={4} r={3} stroke="#5C5CEB" strokeWidth={1.4} />
      <circle cx={9.5} cy={8.5} r={2.5} stroke="#5C5CEB" strokeWidth={1.4} />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="M17.866 8.998a8.5 8.5 0 1 1-6.851-6.862"
      />
      <ellipse
        cx={9.5}
        cy={15.864}
        stroke="#5C5CEB"
        strokeWidth={1.4}
        rx={4.5}
        ry={2.864}
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="M9.5 13v3"
      />
    </g>
    <defs>
      <clipPath id="a22">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const RequestIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a26)">
      <g
        stroke="#0A122E"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#b26)"
      >
        <path
          strokeMiterlimit={10}
          strokeWidth={1.6}
          d="M18.334 8.333v2.5c0 3.334-1.667 5-5 5h-.417a.845.845 0 0 0-.667.334L11 17.833c-.55.734-1.45.734-2 0l-1.25-1.666c-.133-.184-.441-.334-.666-.334h-.417c-3.333 0-5-.833-5-5V6.667c0-3.334 1.667-5 5-5h5"
        />
        <path
          fill="#0A122E"
          strokeWidth={1.5}
          d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
          opacity={0.2}
        />
        <path
          strokeWidth={1.6}
          d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
        />
        <path
          strokeWidth={2}
          d="M13.331 9.167h.008M9.997 9.167h.008M6.662 9.167h.008"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a26">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
      <clipPath id="b26">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const NewRequestIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a26)">
      <g
        stroke="#6666ec"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#b26)"
      >
        <path
          strokeMiterlimit={10}
          strokeWidth={1.6}
          d="M18.334 8.333v2.5c0 3.334-1.667 5-5 5h-.417a.845.845 0 0 0-.667.334L11 17.833c-.55.734-1.45.734-2 0l-1.25-1.666c-.133-.184-.441-.334-.666-.334h-.417c-3.333 0-5-.833-5-5V6.667c0-3.334 1.667-5 5-5h5"
        />
        <path
          fill="#fff"
          strokeWidth={1.5}
          d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
          opacity={0.2}
        />
        <path
          strokeWidth={1.6}
          d="M16.25 5.833a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z"
        />
        <path
          strokeWidth={2}
          d="M13.331 9.167h.008M9.997 9.167h.008M6.662 9.167h.008"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a26">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
      <clipPath id="b26">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const BagelAiIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-9 9"
    />
    <path stroke="url(#a27)" strokeWidth={6} d="M16 10a6 6 0 1 0-6 6" />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.45 5.091A6 6 0 0 1 16 10.003M10 4c.327 0 .653.027.976.08"
    />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0h0ZM13.5 19v-3.5A1.5 1.5 0 0 1 15 14v0a1.5 1.5 0 0 1 1.5 1.5V19"
    />
    <path stroke="black" strokeWidth={1.4} d="M14 17.5h2.5" />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 19v-5"
    />
    <defs>
      <linearGradient
        id="a27"
        x1={3}
        x2={12}
        y1={3}
        y2={12}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="black" stopOpacity={0.04} />
        <stop offset={1} stopColor="black" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)

export const BagelAiIcon2 = (props) => (
  <svg width="47" height="52" viewBox="0 0 47 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.40039 29.4737C7.40039 19.7534 15.2802 11.8737 25.0004 11.8737C34.7206 11.8737 42.6004 19.7534 42.6004 29.4737C42.6004 39.1939 34.7206 47.0737 25.0004 47.0737C15.2802 47.0737 7.40039 39.1939 7.40039 29.4737ZM25.0004 23.607C21.7603 23.607 19.1337 26.2336 19.1337 29.4737C19.1337 32.7137 21.7603 35.3403 25.0004 35.3403C28.2405 35.3403 30.8671 32.7137 30.8671 29.4737C30.8671 26.2336 28.2405 23.607 25.0004 23.607ZM30.9254 17.9475C31.2726 17.4004 31.9976 17.2383 32.5448 17.5855C34.5472 18.8563 36.1962 20.6123 37.3387 22.6906C38.4813 24.7689 39.0803 27.1021 39.0803 29.4737C39.0803 30.1217 38.555 30.647 37.907 30.647C37.259 30.647 36.7337 30.1217 36.7337 29.4737C36.7337 27.4973 36.2345 25.553 35.2823 23.8211C34.3302 22.0892 32.9561 20.6259 31.2874 19.5669C30.7402 19.2197 30.5782 18.4946 30.9254 17.9475ZM27.2063 15.5675C26.3319 15.4288 25.4464 15.3729 24.5615 15.4005C23.9138 15.4207 23.4051 15.9621 23.4253 16.6098C23.4455 17.2575 23.9869 17.7662 24.6346 17.746C25.3721 17.723 26.11 17.7696 26.8387 17.8852C27.4787 17.9867 28.0798 17.5502 28.1813 16.9102C28.2829 16.2702 27.8463 15.6691 27.2063 15.5675Z" fill="#FF8700"/>
    <path d="M2 18.0238C2 17.9747 2.03679 17.9334 2.0854 17.9269C7.03095 17.2709 10.9471 13.3546 11.6027 8.40891C11.6091 8.36036 11.6504 8.32361 11.6994 8.32361C11.7484 8.32361 11.7897 8.36036 11.7961 8.40891C12.4518 13.355 16.3686 17.2717 21.3148 17.9271C21.3633 17.9335 21.4 17.9748 21.4 18.0238C21.4 18.0727 21.3633 18.114 21.3148 18.1204C16.3687 18.7758 12.452 22.6923 11.7962 27.6383C11.7897 27.6868 11.7484 27.7236 11.6994 27.7236C11.6504 27.7236 11.6091 27.6868 11.6026 27.6383C10.9469 22.6927 7.03084 18.7765 2.0854 18.1206C2.03679 18.1141 2 18.0728 2 18.0238Z" fill="#5C5CEB"/>
    <path d="M15 5.62499C15 5.59655 15.0213 5.57258 15.0495 5.56884C17.9174 5.18844 20.1883 2.9174 20.5685 0.0494671C20.5722 0.0213104 20.5962 0 20.6246 0C20.653 0 20.6769 0.0213109 20.6806 0.0494676C21.0609 2.91766 23.3321 5.18885 26.2004 5.56894C26.2285 5.57267 26.2498 5.5966 26.2498 5.62499C26.2498 5.65337 26.2285 5.6773 26.2004 5.68103C23.3322 6.06111 21.061 8.33222 20.6807 11.2003C20.6769 11.2285 20.653 11.2498 20.6246 11.2498C20.5961 11.2498 20.5722 11.2285 20.5684 11.2003C20.1882 8.33248 17.9173 6.06152 15.0495 5.68113C15.0213 5.6774 15 5.65342 15 5.62499Z" fill="#5C5CEB"/>
  </svg>

)

export const BagelGeneratedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-9 9"
    />
    <path stroke="url(#a27)" strokeWidth={6} d="M16 10a6 6 0 1 0-6 6" />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.45 5.091A6 6 0 0 1 16 10.003M10 4c.327 0 .653.027.976.08"
    />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0h0ZM13.5 19v-3.5A1.5 1.5 0 0 1 15 14v0a1.5 1.5 0 0 1 1.5 1.5V19"
    />
    <path stroke="black" strokeWidth={1.4} d="M14 17.5h2.5" />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 19v-5"
    />
    <defs>
      <linearGradient
        id="a27"
        x1={3}
        x2={12}
        y1={3}
        y2={12}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="black" stopOpacity={0.04} />
        <stop offset={1} stopColor="black" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)

export const PurpuleBagelAiIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-9 9"
    />
    <path stroke="url(#a27)" strokeWidth={6} d="M16 10a6 6 0 1 0-6 6" />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.45 5.091A6 6 0 0 1 16 10.003M10 4c.327 0 .653.027.976.08"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0h0ZM13.5 19v-3.5A1.5 1.5 0 0 1 15 14v0a1.5 1.5 0 0 1 1.5 1.5V19"
    />
    <path stroke="#5C5CEB" strokeWidth={1.4} d="M14 17.5h2.5" />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 19v-5"
    />
    <defs>
      <linearGradient
        id="a27"
        x1={3}
        x2={12}
        y1={3}
        y2={12}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5C5CEB" stopOpacity={0.04} />
        <stop offset={1} stopColor="#5C5CEB" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)

export const PurpuleBagelGenerated = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-9 9"
    />
    <path stroke="url(#a27)" strokeWidth={6} d="M16 10a6 6 0 1 0-6 6" />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.45 5.091A6 6 0 0 1 16 10.003M10 4c.327 0 .653.027.976.08"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0h0ZM13.5 19v-3.5A1.5 1.5 0 0 1 15 14v0a1.5 1.5 0 0 1 1.5 1.5V19"
    />
    <path stroke="#5C5CEB" strokeWidth={1.4} d="M14 17.5h2.5" />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 19v-5"
    />
    <defs>
      <linearGradient
        id="a27"
        x1={3}
        x2={12}
        y1={3}
        y2={12}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5C5CEB" stopOpacity={0.04} />
        <stop offset={1} stopColor="#5C5CEB" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)

export const GeneratedIcon = ({height=12, width=13, fill = "#fff", ...rest}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...rest}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M.5 6a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm2.02-1.93a.4.4 0 0 1 .552-.123A4.8 4.8 0 0 1 11.3 6a.4.4 0 0 1-.8 0 4 4 0 0 0-1.857-3.377.4.4 0 0 1-.123-.552Zm-1.268-.81a4.8 4.8 0 0 0-.902-.058.4.4 0 0 0 .025.8 4 4 0 0 1 .752.047.4.4 0 0 0 .125-.79Z"
      clipRule="evenodd"
    />
  </svg>
)

export const GeneratedChosenIcon = ({height=20, width=21, fill = "#FF8700", ...rest}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...rest}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M2.5 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-2.667a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334Zm2.693-2.572a.533.533 0 0 1 .736-.165A6.4 6.4 0 0 1 16.9 10a.533.533 0 0 1-1.067 0 5.333 5.333 0 0 0-2.475-4.503.533.533 0 0 1-.165-.736Zm-1.69-1.082a6.4 6.4 0 0 0-1.203-.076.533.533 0 1 0 .034 1.066c.335-.01.67.011 1.002.064a.533.533 0 0 0 .167-1.054Z"
      clipRule="evenodd"
    />
  </svg>
)

import * as animationData from './loaderLottie.json'
import Lottie from 'react-lottie';

export const Loader = ({height=74, width= 74, isStopped= false, isPaused= false}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };


  return <Lottie options={defaultOptions}
    height={height}
    width={width}
    isStopped={isStopped}
    isPaused={isPaused}
  />
}


export const VivunIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path fill="url(#a28)" d="M3 3h18v18H3z" />
    <defs>
      <pattern
        id="a28"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#b28" transform="scale(.002)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="b28"
        width={500}
        height={500}
      />
    </defs>
  </svg>
)

export const PendoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path fill="url(#a29)" d="M4 4h16v16H4z" />
    <defs>
      <pattern
        id="a29"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#b29" transform="scale(.00357)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="b29"
        width={280}
        height={280}
      />
    </defs>
  </svg>
)

export const ChurnReasonsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#F0887F"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M14 6V4a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v5m12 2v2a3 3 0 0 1-3 3H9.25"
    />
    <path
      fill="#F0887F"
      d="m7.338 3.464-2.5-1.154A2 2 0 0 0 2 4.126V14.72a2 2 0 0 0 1.162 1.816l3.21 1.482A1.5 1.5 0 0 0 8.5 16.656V5.28a2 2 0 0 0-1.162-1.816Z"
      opacity={0.1}
    />
    <path
      stroke="#F0887F"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="m7.338 3.464-2.5-1.154A2 2 0 0 0 2 4.126V14.72a2 2 0 0 0 1.162 1.816l3.21 1.482A1.5 1.5 0 0 0 8.5 16.656V5.28a2 2 0 0 0-1.162-1.816ZM6.5 9.5V11"
    />
    <path
      stroke="#F0887F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.5 8.5h6M16.5 6.5l2 2-2 2"
    />
  </svg>
)

export const CustomerCallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <rect
      width={5}
      height={6}
      x={1}
      y={8}
      fill="#CD81E4"
      opacity={0.2}
      rx={2.5}
    />
    <rect
      width={5}
      height={6}
      x={14}
      y={8}
      fill="#CD81E4"
      opacity={0.2}
      rx={2.5}
    />
    <rect
      width={4}
      height={3}
      x={9}
      y={16}
      fill="#CD81E4"
      opacity={0.2}
      rx={1.5}
    />
    <path stroke="#CD81E4" strokeWidth={1.4} d="M17 8A7 7 0 1 0 3 8" />
    <rect
      width={5}
      height={6}
      x={1}
      y={8}
      stroke="#CD81E4"
      strokeWidth={1.4}
      rx={2.5}
    />
    <rect
      width={5}
      height={6}
      x={14}
      y={8}
      stroke="#CD81E4"
      strokeWidth={1.4}
      rx={2.5}
    />
    <rect
      width={4}
      height={3}
      x={9}
      y={16}
      stroke="#CD81E4"
      strokeWidth={1.4}
      rx={1.5}
    />
    <path stroke="#CD81E4" strokeWidth={1.4} d="M17 14a4 4 0 0 1-4 4" />
  </svg>
)

export const GeneralIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#46D3CA"
      strokeWidth={6}
      d="M7.704 15.543A6 6 0 0 0 10 16c3.5 0 6-3 6-6a6 6 0 1 0-8.296 5.543Z"
      opacity={0.1}
    />
    <path
      stroke="#46D3CA"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.45 5.091A6 6 0 0 1 16 10.003M10 4c.327 0 .653.027.976.08"
    />
    <path
      stroke="#46D3CA"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0h0Z"
    />
    <circle cx={10} cy={10} r={9} stroke="#46D3CA" strokeWidth={1.4} />
  </svg>
)

export const GeneralPurpuleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5CEB"
      strokeWidth={6}
      d="M7.704 15.543A6 6 0 0 0 10 16c3.5 0 6-3 6-6a6 6 0 1 0-8.296 5.543Z"
      opacity={0.1}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M13.45 5.091A6 6 0 0 1 16 10.003M10 4c.327 0 .653.027.976.08"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0h0Z"
    />
    <circle cx={10} cy={10} r={9} stroke="#5C5CEB" strokeWidth={1.4} />
  </svg>
)

export const HealthNotesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#F5AF4E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 3H7a4 4 0 0 0-4 4v7a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4Z"
    />
    <path
      stroke="#F5AF4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m6.005 11.055 1.198-.014c.094 0 .237.04.383.14a.78.78 0 0 1 .263.283l.785 2.844a1.473 1.473 0 0 0 .326.558.94.94 0 0 0 .674.297c.302 0 .531-.15.675-.297a1.475 1.475 0 0 0 .326-.558l1.28-4.645.347 1.075a.703.703 0 0 0 .047.11c.182.347.48.62.786.804.305.184.684.32 1.073.32h-.158"
      opacity={0.2}
    />
    <path
      stroke="#F5AF4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m5 10.355 2.2-.014c.526 0 1.114.4 1.31.89l.798 2.891c.182.455.47.455.651 0l1.604-5.818c.154-.392.44-.406.637-.035l.728 2.254c.217.413.777.75 1.24.75h.842"
    />
    <path
      stroke="#F5AF4E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 1.5V4M7 1.5V4"
    />
  </svg>
)

export const LostHoldReasonIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#F0887F"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M14 2H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Z"
    />
    <path
      stroke="#F0887F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.4}
      d="M5.833 7.292a2.153 2.153 0 0 1 3.033 0M11.134 7.292a2.153 2.153 0 0 1 3.033 0"
    />
    <path
      fill="#F0887F"
      d="M7 14.75h6c.417 0 .75-.333.75-.75A3.745 3.745 0 0 0 10 10.25 3.745 3.745 0 0 0 6.25 14c0 .417.333.75.75.75Z"
      opacity={0.2}
    />
    <path
      stroke="#F0887F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.4}
      d="M7 14.75h6c.417 0 .75-.333.75-.75A3.745 3.745 0 0 0 10 10.25 3.745 3.745 0 0 0 6.25 14c0 .417.333.75.75.75Z"
    />
  </svg>
)

export const PmFeedbackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <circle cx={10} cy={6.5} r={1.5} fill="#F580BD" opacity={0.1} />
    <path
      fill="#F580BD"
      d="M13 12c0 1.325-1.343 1.6-3 1.6s-3-.274-3-1.6c0-1.325 1.343-2.4 3-2.4s3 1.075 3 2.4Z"
      opacity={0.1}
    />
    <circle cx={10} cy={6.5} r={1.5} stroke="#F580BD" strokeWidth={1.4} />
    <path
      stroke="#F580BD"
      strokeWidth={1.4}
      d="M13 12c0 1.325-1.343 1.6-3 1.6s-3-.274-3-1.6c0-1.325 1.343-2.4 3-2.4s3 1.075 3 2.4Z"
    />
    <path
      stroke="#F580BD"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M10 10v1"
    />
    <path
      stroke="#F580BD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M2.5 6v5.6a4 4 0 0 0 4 4h.049a1 1 0 0 1 .75.338L9.25 18.15a1 1 0 0 0 1.5 0l1.951-2.212a1 1 0 0 1 .75-.338h.049a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4h-7a4 4 0 0 0-4 4Z"
    />
  </svg>
)

export const SupportCaseTicketIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#48A4EF"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M10.474 11.687S7.3 15.525 6.544 16.28c-.754.755-2.046.781-2.827 0-.782-.78-.756-2.073 0-2.828.755-.755 4.593-3.928 4.593-3.928"
    />
    <path
      fill="#48A4EF"
      d="M3.47 15.041a1.5 1.5 0 0 0 1.5 1.5c.829 0 5.036-4.207 5.036-5.035a1.5 1.5 0 0 0-1.5-1.5c-.829 0-5.036 4.207-5.036 5.035Z"
      opacity={0.2}
    />
    <path
      stroke="#48A4EF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M8.302 9.294a5.002 5.002 0 0 1 6.181-6.845L12.47 4.452l-.877.891.314 1.21.333 1.205 1.205.333 1.21.314.89-.877 2.004-2.014a5 5 0 0 1-6.845 6.182"
    />
  </svg>
)

export const SurveyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#BFA269"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M14 2H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Z"
    />
    <g stroke="#BFA269" strokeLinecap="round" strokeWidth={1.4} opacity={0.2}>
      <path d="M10.5 9.5H14" />
      <path strokeLinejoin="round" d="m5.5 9.38.888.888L8.3 8.5" />
    </g>
    <g stroke="#BFA269" strokeLinecap="round" strokeWidth={1.4} opacity={0.2}>
      <path d="M10.5 13.5H14" />
      <path strokeLinejoin="round" d="m5.5 13.38.888.888L8.3 12.5" />
    </g>
    <path
      stroke="#BFA269"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M10.5 8.5H14"
    />
    <path
      stroke="#BFA269"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m5.5 8.38.888.888L8.3 7.5"
    />
    <path
      stroke="#BFA269"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M10.5 12.5H14"
    />
    <path
      stroke="#BFA269"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m5.5 12.38.888.888L8.3 11.5"
    />
  </svg>
)

export const RequestBusinessnameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#5C5CEB"
        d="M4 10H2a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1Z"
        opacity={0.2}
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="M4 10H2a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1ZM5.5 11.5l2.495-.72a3 3 0 0 1 1.658 0l3 .859a1.5 1.5 0 1 1-.926 2.854l-2.903-.783"
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="m13.289 14.171 3.59-1.88a1.5 1.5 0 1 1 1.391 2.659l-7.354 3.849a2 2 0 0 1-1.873-.01L5.336 16.8"
      />
      <path
        fill="#5C5CEB"
        d="M12.002 6.633 9.53 8l.472-2.895-2.003-2.05 2.764-.421L11.999 0l1.236 2.634L16 3.055l-2.003 2.05L14.47 8l-2.467-1.367Z"
        opacity={0.2}
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        d="m12.002 6.633-1.391.77a.6.6 0 0 1-.882-.623l.273-1.675-1.186-1.214a.6.6 0 0 1 .339-1.012l1.608-.245.693-1.477a.6.6 0 0 1 1.086 0l.693 1.477 1.608.245a.6.6 0 0 1 .339 1.012l-1.186 1.214.273 1.674a.6.6 0 0 1-.883.621l-1.384-.767Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const ReportsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#0A122E"
      d="M15.267 10c2.167 0 3.067-.833 2.267-3.567-.542-1.841-2.125-3.425-3.967-3.966-2.733-.8-3.567.1-3.567 2.266v2.4C10 9.167 10.834 10 12.5 10h2.767Z"
      opacity={0.2}
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M15.267 10c2.167 0 3.067-.833 2.267-3.567-.542-1.841-2.125-3.425-3.967-3.966-2.733-.8-3.567.1-3.567 2.266v2.4C10 9.167 10.834 10 12.5 10h2.767Z"
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M16.364 13.334a7.574 7.574 0 0 1-8.38 4.891c-3.159-.508-5.7-3.05-6.217-6.208a7.586 7.586 0 0 1 4.9-8.38"
    />
  </svg>
);

export const ReportsIconSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#5C5CEB"
      d="M15.267 10c2.167 0 3.067-.833 2.267-3.567-.542-1.841-2.125-3.425-3.967-3.966-2.733-.8-3.567.1-3.567 2.266v2.4C10 9.167 10.834 10 12.5 10h2.767Z"
      opacity={0.2}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M15.267 10c2.167 0 3.067-.833 2.267-3.567-.542-1.841-2.125-3.425-3.967-3.966-2.733-.8-3.567.1-3.567 2.266v2.4C10 9.167 10.834 10 12.5 10h2.767Z"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M16.364 13.334a7.574 7.574 0 0 1-8.38 4.891c-3.159-.508-5.7-3.05-6.217-6.208a7.586 7.586 0 0 1 4.9-8.38"
    />
  </svg>
);

export const PlusIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <rect width={16} height={16} x={2} y={2} fill="#FDFEFF" rx={4.5} />
    <rect
      width={16}
      height={16}
      x={2}
      y={2}
      stroke="#5C5CEB"
      strokeWidth={1.4}
      rx={4.5}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M10 7.5v5M12.5 10h-5"
    />
  </svg>
);

export const AccountNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#0A122E"
      d="M6 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3l-4 2.5L6 16ZM10 10.66A2.33 2.33 0 1 0 10 6a2.33 2.33 0 0 0 0 4.66Z"
      opacity={0.1}
    />
    <path
      stroke="#0A122E"
      strokeWidth={1.4}
      d="m3.636 4.887 4.8-2.932a3 3 0 0 1 3.128 0l4.8 2.932a3 3 0 0 1 1.436 2.56v5.105a3 3 0 0 1-1.436 2.56l-4.8 2.933a3 3 0 0 1-3.128 0l-4.8-2.932a3 3 0 0 1-1.436-2.56V7.447a3 3 0 0 1 1.436-2.56Z"
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10 10.66A2.33 2.33 0 1 0 10 6a2.33 2.33 0 0 0 0 4.66Z"
    />
    <path
      stroke="#0A122E"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M14.5 16.32c0-1.8-2.014-3.26-4.5-3.26s-4.5 1.46-4.5 3.26"
    />
  </svg>
);

export const TeamsNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#0A122E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        d="M15 5.967a.505.505 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15c0-1.192.958-2.15 2.15-2.15a2.15 2.15 0 0 1 .075 4.3ZM14.142 12.033c1.142.192 2.4-.008 3.283-.6 1.175-.783 1.175-2.066 0-2.85-.892-.591-2.167-.791-3.308-.591M4.975 5.967a.505.505 0 0 1 .158 0A2.144 2.144 0 0 0 7.2 3.817c0-1.192-.958-2.15-2.15-2.15a2.15 2.15 0 0 0-.075 4.3ZM5.833 12.033c-1.141.192-2.4-.008-3.283-.6-1.175-.783-1.175-2.066 0-2.85.892-.591 2.167-.791 3.308-.591"
      />
      <path
        fill="#0A122E"
        d="M10 12.192a.507.507 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15 2.15 2.15 0 1 1 4.3 0c-.008 1.166-.925 2.116-2.075 2.15ZM7.204 14.817c-1.352.783-1.352 2.067 0 2.85 1.534.891 4.047.891 5.582 0 1.352-.784 1.352-2.067 0-2.85-1.525-.883-4.048-.883-5.582 0Z"
        opacity={0.1}
      />
      <path
        stroke="#0A122E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        d="M10 12.192a.506.506 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15c0-1.192.958-2.15 2.15-2.15a2.15 2.15 0 0 1 2.15 2.15c-.008 1.166-.925 2.116-2.075 2.15ZM7.204 14.817c-1.352.783-1.352 2.067 0 2.85 1.535.891 4.048.891 5.582 0 1.352-.784 1.352-2.067 0-2.85-1.525-.883-4.047-.883-5.582 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ProductAreaNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#0A122E"
      d="m6.413 6.82 2.5-1.617a2 2 0 0 1 2.173 0l2.5 1.618A2 2 0 0 1 14.5 8.5v3a2 2 0 0 1-.914 1.68l-2.5 1.617a2 2 0 0 1-2.172 0l-2.5-1.618A2 2 0 0 1 5.5 11.5v-3a2 2 0 0 1 .913-1.68Z"
      opacity={0.1}
    />
    <path
      stroke="#0A122E"
      strokeWidth={1.4}
      d="m6.413 6.82 2.5-1.617a2 2 0 0 1 2.173 0l2.5 1.618A2 2 0 0 1 14.5 8.5v3a2 2 0 0 1-.914 1.68l-2.5 1.617a2 2 0 0 1-2.172 0l-2.5-1.618A2 2 0 0 1 5.5 11.5v-3a2 2 0 0 1 .913-1.68ZM10 15v-5m0 0 4-2.5M10 10 6 7.5"
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-7.461 8.867M17.287 15.282a8.998 8.998 0 0 0 1.382-2.865M15.569 17.07l.148-.119"
    />
  </svg>
);

export const ObjectsFieldsNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#0A122E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="M7.5 4.167h5.833M10.417 4.167v10.5a2 2 0 0 0 2.002 2h.914M10.417 10.417h2.916"
      />
      <rect
        width={5.83}
        height={5}
        x={1.67}
        y={1.67}
        fill="#0A122E"
        opacity={0.1}
        rx={1.6}
      />
      <rect
        width={5.83}
        height={5}
        x={1.67}
        y={1.67}
        stroke="#0A122E"
        strokeWidth={1.4}
        rx={1.6}
      />
      <rect
        width={5}
        height={3.33}
        x={13.33}
        y={2.5}
        stroke="#0A122E"
        strokeWidth={1.4}
        rx={1}
      />
      <rect
        width={5}
        height={3.33}
        x={13.33}
        y={8.75}
        stroke="#0A122E"
        strokeWidth={1.4}
        rx={1}
      />
      <rect
        width={5}
        height={3.33}
        x={13.33}
        y={15}
        stroke="#0A122E"
        strokeWidth={1.4}
        rx={1}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const IntegrationsNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#0A122E"
        d="m4.697 10.146 5.657 5.657-1.415 1.415a3 3 0 0 1-4.242 0l-1.415-1.415a3 3 0 0 1 0-4.242l1.415-1.415Z"
        opacity={0.1}
      />
      <path
        stroke="#0A122E"
        strokeWidth={1.4}
        d="m4.697 10.146 5.657 5.657-1.415 1.415a3 3 0 0 1-4.242 0l-1.415-1.415a3 3 0 0 1 0-4.242l1.415-1.415Z"
      />
      <path
        stroke="#0A122E"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="m3.99 9.44 7.07 7.07"
      />
      <path
        fill="#0A122E"
        d="M11.98 12.338a.7.7 0 0 0-.99-.99l.99.99Zm-2.475 2.475 2.475-2.475-.99-.99-2.475 2.475.99.99ZM9.151 9.51a.7.7 0 1 0-.99-.99l.99.99Zm-2.474 2.475L9.15 9.51l-.99-.99-2.474 2.475.99.99ZM1.373 18.137a.7.7 0 0 0 .99.99l-.99-.99Zm.99.99 2.122-2.121-.99-.99-2.122 2.12.99.99Z"
      />
      <path
        stroke="#0A122E"
        strokeWidth={1.4}
        d="m9.646 5.197 5.657 5.657 1.415-1.415a3 3 0 0 0 0-4.242l-1.415-1.414a3 3 0 0 0-4.242 0L9.646 5.197Z"
      />
      <path
        stroke="#0A122E"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="m8.94 4.49 7.07 7.07"
      />
      <path
        fill="#0A122E"
        d="M17.637 1.873a.7.7 0 0 1 .99.99l-.99-.99Zm.99.99-2.122 2.121-.99-.99 2.122-2.12.99.99Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ImportNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M7.8 10v3M6 12.4l1.734 1.54a.1.1 0 0 0 .132 0L9.6 12.4"
    />
    <path
      stroke="#0A122E"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M2 6a4 4 0 0 1 4-4h5.5L18 8.5V14a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Z"
    />
    <path
      fill="#0A122E"
      d="M11.5 5.5V2L18 8.5h-3.5a3 3 0 0 1-3-3Z"
      opacity={0.1}
    />
    <path
      stroke="#0A122E"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M11.5 5.5V2L18 8.5h-3.5a3 3 0 0 1-3-3Z"
    />
  </svg>
);

export const MembersNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <circle cx={7.5} cy={5.5} r={3.5} stroke="#0A122E" strokeWidth={1.4} />
    <path
      fill="#0A122E"
      d="M16 6a3 3 0 0 1-3 3V3a3 3 0 0 1 3 3ZM18 14a3 3 0 0 1-3 3v-6a3 3 0 0 1 3 3Z"
      opacity={0.1}
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 9a3 3 0 1 0 0-6"
    />
    <ellipse
      cx={7.5}
      cy={14.5}
      stroke="#0A122E"
      strokeWidth={1.4}
      rx={5.5}
      ry={3.5}
    />
    <path
      stroke="#0A122E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M15.368 11.27C16.921 11.743 18 12.787 18 14c0 1.212-1.08 2.257-2.632 2.73"
    />
  </svg>
);

export const AccountNivSelectedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#5C5CEB"
      d="M6 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3l-4 2.5L6 16ZM10 10.66A2.33 2.33 0 1 0 10 6a2.33 2.33 0 0 0 0 4.66Z"
      opacity={0.1}
    />
    <path
      stroke="#5C5CEB"
      strokeWidth={1.4}
      d="m3.636 4.887 4.8-2.932a3 3 0 0 1 3.128 0l4.8 2.932a3 3 0 0 1 1.436 2.56v5.105a3 3 0 0 1-1.436 2.56l-4.8 2.933a3 3 0 0 1-3.128 0l-4.8-2.932a3 3 0 0 1-1.436-2.56V7.447a3 3 0 0 1 1.436-2.56Z"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10 10.66A2.33 2.33 0 1 0 10 6a2.33 2.33 0 0 0 0 4.66Z"
    />
    <path
      stroke="#5C5CEB"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M14.5 16.32c0-1.8-2.014-3.26-4.5-3.26s-4.5 1.46-4.5 3.26"
    />
  </svg>
);

export const MembersNivSelectedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <circle cx={7.5} cy={5.5} r={3.5} stroke="#5C5CEB" strokeWidth={1.4} />
    <path
      fill="#5C5CEB"
      d="M16 6a3 3 0 0 1-3 3V3a3 3 0 0 1 3 3ZM18 14a3 3 0 0 1-3 3v-6a3 3 0 0 1 3 3Z"
      opacity={0.1}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M13 9a3 3 0 1 0 0-6"
    />
    <ellipse
      cx={7.5}
      cy={14.5}
      stroke="#5C5CEB"
      strokeWidth={1.4}
      rx={5.5}
      ry={3.5}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M15.368 11.27C16.921 11.743 18 12.787 18 14c0 1.212-1.08 2.257-2.632 2.73"
    />
  </svg>
);

export const TeamsNivSelectedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        d="M15 5.967a.505.505 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15c0-1.192.958-2.15 2.15-2.15a2.15 2.15 0 0 1 .075 4.3ZM14.142 12.033c1.142.192 2.4-.008 3.283-.6 1.175-.783 1.175-2.066 0-2.85-.892-.591-2.167-.791-3.308-.591M4.975 5.967a.505.505 0 0 1 .158 0A2.144 2.144 0 0 0 7.2 3.817c0-1.192-.958-2.15-2.15-2.15a2.15 2.15 0 0 0-.075 4.3ZM5.833 12.033c-1.141.192-2.4-.008-3.283-.6-1.175-.783-1.175-2.066 0-2.85.892-.591 2.167-.791 3.308-.591"
      />
      <path
        fill="#5C5CEB"
        d="M10 12.192a.507.507 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15 2.15 2.15 0 1 1 4.3 0c-.008 1.166-.925 2.116-2.075 2.15ZM7.204 14.817c-1.352.783-1.352 2.067 0 2.85 1.534.891 4.047.891 5.582 0 1.352-.784 1.352-2.067 0-2.85-1.525-.883-4.048-.883-5.582 0Z"
        opacity={0.1}
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        d="M10 12.192a.506.506 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15c0-1.192.958-2.15 2.15-2.15a2.15 2.15 0 0 1 2.15 2.15c-.008 1.166-.925 2.116-2.075 2.15ZM7.204 14.817c-1.352.783-1.352 2.067 0 2.85 1.535.891 4.048.891 5.582 0 1.352-.784 1.352-2.067 0-2.85-1.525-.883-4.047-.883-5.582 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ProductAreaNivSelectedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#5C5CEB"
      d="m6.413 6.82 2.5-1.617a2 2 0 0 1 2.173 0l2.5 1.618A2 2 0 0 1 14.5 8.5v3a2 2 0 0 1-.914 1.68l-2.5 1.617a2 2 0 0 1-2.172 0l-2.5-1.618A2 2 0 0 1 5.5 11.5v-3a2 2 0 0 1 .913-1.68Z"
      opacity={0.1}
    />
    <path
      stroke="#5C5CEB"
      strokeWidth={1.4}
      d="m6.413 6.82 2.5-1.617a2 2 0 0 1 2.173 0l2.5 1.618A2 2 0 0 1 14.5 8.5v3a2 2 0 0 1-.914 1.68l-2.5 1.617a2 2 0 0 1-2.172 0l-2.5-1.618A2 2 0 0 1 5.5 11.5v-3a2 2 0 0 1 .913-1.68ZM10 15v-5m0 0 4-2.5M10 10 6 7.5"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M19 10a9 9 0 1 0-7.461 8.867M17.287 15.282a8.998 8.998 0 0 0 1.382-2.865M15.569 17.07l.148-.119"
    />
  </svg>
);

export const ObjectsFieldsSelectedNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="M7.5 4.167h5.833M10.417 4.167v10.5a2 2 0 0 0 2.002 2h.914M10.417 10.417h2.916"
      />
      <rect
        width={5.83}
        height={5}
        x={1.67}
        y={1.67}
        fill="#5C5CEB"
        opacity={0.1}
        rx={1.6}
      />
      <rect
        width={5.83}
        height={5}
        x={1.67}
        y={1.67}
        stroke="#5C5CEB"
        strokeWidth={1.4}
        rx={1.6}
      />
      <rect
        width={5}
        height={3.33}
        x={13.33}
        y={2.5}
        stroke="#5C5CEB"
        strokeWidth={1.4}
        rx={1}
      />
      <rect
        width={5}
        height={3.33}
        x={13.33}
        y={8.75}
        stroke="#5C5CEB"
        strokeWidth={1.4}
        rx={1}
      />
      <rect
        width={5}
        height={3.33}
        x={13.33}
        y={15}
        stroke="#5C5CEB"
        strokeWidth={1.4}
        rx={1}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const IntegrationsSelectedNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#5C5CEB"
        d="m4.697 10.146 5.657 5.657-1.415 1.415a3 3 0 0 1-4.242 0l-1.415-1.415a3 3 0 0 1 0-4.242l1.415-1.415Z"
        opacity={0.1}
      />
      <path
        stroke="#5C5CEB"
        strokeWidth={1.4}
        d="m4.697 10.146 5.657 5.657-1.415 1.415a3 3 0 0 1-4.242 0l-1.415-1.415a3 3 0 0 1 0-4.242l1.415-1.415Z"
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="m3.99 9.44 7.07 7.07"
      />
      <path
        fill="#5C5CEB"
        d="M11.98 12.338a.7.7 0 0 0-.99-.99l.99.99Zm-2.475 2.475 2.475-2.475-.99-.99-2.475 2.475.99.99ZM9.151 9.51a.7.7 0 1 0-.99-.99l.99.99Zm-2.474 2.475L9.15 9.51l-.99-.99-2.474 2.475.99.99ZM1.373 18.137a.7.7 0 0 0 .99.99l-.99-.99Zm.99.99 2.122-2.121-.99-.99-2.122 2.12.99.99Z"
      />
      <path
        stroke="#5C5CEB"
        strokeWidth={1.4}
        d="m9.646 5.197 5.657 5.657 1.415-1.415a3 3 0 0 0 0-4.242l-1.415-1.414a3 3 0 0 0-4.242 0L9.646 5.197Z"
      />
      <path
        stroke="#5C5CEB"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="m8.94 4.49 7.07 7.07"
      />
      <path
        fill="#5C5CEB"
        d="M17.637 1.873a.7.7 0 0 1 .99.99l-.99-.99Zm.99.99-2.122 2.121-.99-.99 2.122-2.12.99.99Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ImportSelectedNivIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M7.8 10v3M6 12.4l1.734 1.54a.1.1 0 0 0 .132 0L9.6 12.4"
    />
    <path
      stroke="#5C5CEB"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M2 6a4 4 0 0 1 4-4h5.5L18 8.5V14a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Z"
    />
    <path
      fill="#5C5CEB"
      d="M11.5 5.5V2L18 8.5h-3.5a3 3 0 0 1-3-3Z"
      opacity={0.1}
    />
    <path
      stroke="#5C5CEB"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M11.5 5.5V2L18 8.5h-3.5a3 3 0 0 1-3-3Z"
    />
  </svg>
);

export const ApiSelectedNivIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" 
    class="__mantine-ref-icon" 
    width="24" 
    height="24"
    color="#5C5CF0"
    viewBox="0 0 24 24" 
    stroke-width="1.5" 
    stroke="currentColor" 
    fill="none" 
    stroke-linecap="round" 
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"></path>
    <path d="M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5"></path>
    <path d="M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5"></path>
    <path d="M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5"></path></svg>
);

export const BusinessNameNotification = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <title>New comment for you</title>
    <g fill="#5C5CEB">
      <path
        fillRule="evenodd"
        d="M8 2a.5.5 0 0 1 .5.5v1.531c1.196.147 2.173.817 2.854 1.964.759 1.277 1.146 3.13 1.146 5.505h.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1 0-1h.501c-.015-2.374.363-4.227 1.118-5.504C5.303 4.839 6.29 4.167 7.5 4.027V2.5A.5.5 0 0 1 8 2Z"
        clipRule="evenodd"
      />
      <path d="M7 13a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H7Z" />
    </g>
    <circle cx={12} cy={5.5} r={3} fill="#0BAC4D" />
  </svg>
);

export const FillIconNotification = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="#5C5CEB"
    {...props}
  >
    <title>This Evidence has comments</title>
    <g fill="#5C5CEB">
      <path
        fillRule="evenodd"
        d="M8 2a.5.5 0 0 1 .5.5v1.531c1.196.147 2.173.817 2.854 1.964.759 1.277 1.146 3.13 1.146 5.505h.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1 0-1h.501c-.015-2.374.363-4.227 1.118-5.504C5.303 4.839 6.29 4.167 7.5 4.027V2.5A.5.5 0 0 1 8 2Z"
        clipRule="evenodd"
      />
      <path d="M7 13a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H7Z" />
    </g>
  </svg>
);

export const ZeroState = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={100}
    fill="none"
    {...props}
  >
    <path
      fill="#DADAF3"
      d="M26 25a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-9ZM26 56a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-9Z"
    />
    <rect width={45} height={4} x={48} y={23} fill="#DADAF3" rx={1} />
    <rect width={45} height={4} x={48} y={54} fill="#DADAF3" rx={1} />
    <rect width={36} height={4} x={48} y={30} fill="#DADAF3" rx={1} />
    <path
      fill="#5C5CEB"
      fillOpacity={0.2}
      d="M69.992 34H49a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h19.674a31.757 31.757 0 0 1 1.318 4Z"
    />
    <rect width={36} height={4} x={48} y={61} fill="#DADAF3" rx={1} />
    <path
      fill="#5C5CEB"
      fillOpacity={0.2}
      d="M64.751 23a32.034 32.034 0 0 1 2.523 4H49a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h15.751ZM64.751 61a32.185 32.185 0 0 1-3.502 4H49a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h15.751ZM68.674 54a31.857 31.857 0 0 1-1.955 4H49a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h19.674Z"
    />
    <path
      fill="#B6B6EE"
      fillRule="evenodd"
      d="M72.074 69.832A38.84 38.84 0 0 0 81 45C81 23.46 63.54 6 42 6S3 23.46 3 45s17.46 39 39 39c9.944 0 19.02-3.722 25.908-9.849l22.97 22.97a3 3 0 1 0 4.243-4.242L72.074 69.832ZM77 45c0 19.33-15.67 35-35 35S7 64.33 7 45s15.67-35 35-35 35 15.67 35 35Z"
      clipRule="evenodd"
    />
  </svg>
);

export const DiscoveryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#212529"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
    />
    <path
      fill="#212529"
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
      opacity={0.2}
    />
    <path stroke="#212529" strokeWidth={1.4} d="M10 2v6" />
    <path
      stroke="#212529"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M15 10a5 5 0 1 1-5-5"
    />
    <path
      stroke="#212529"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M18 10a8 8 0 1 1-8-8"
    />
  </svg>
);

export const DiscoveryIconSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
    />
    <path
      fill="#5C5CEB"
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
      opacity={0.2}
    />
    <path stroke="#5C5CEB" strokeWidth={1.4} d="M10 2v6" />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M15 10a5 5 0 1 1-5-5"
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M18 10a8 8 0 1 1-8-8"
    />
  </svg>
);

export const ConvertIcon = ({ color = "#5C5CEB", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={color}
      d="M5 4.071a5.095 5.095 0 0 0-1.367 1.712A4.896 4.896 0 0 0 3.125 8c0 1.16.344 2.185 1.031 3.074.688.889 1.557 1.471 2.607 1.746a.64.64 0 0 1 .354.26c.089.13.133.27.133.424a.51.51 0 0 1-.156.38.388.388 0 0 1-.375.104c-1.365-.298-2.492-1-3.383-2.107C2.446 10.772 2 9.48 2 8c0-.926.182-1.78.547-2.563A6.42 6.42 0 0 1 4.03 3.4h-.718a.558.558 0 0 1-.563-.572.57.57 0 0 1 .161-.41.533.533 0 0 1 .4-.167h2.247c.16 0 .294.055.403.165.11.11.164.246.164.409V5.12c0 .162-.054.3-.16.411a.53.53 0 0 1-.4.168.544.544 0 0 1-.4-.165.558.558 0 0 1-.165-.41V4.071Zm2.203 4.6 2.531-2.572a.533.533 0 0 1 .391-.175c.146 0 .278.058.398.175a.578.578 0 0 1-.007.815L7.594 9.9a.518.518 0 0 1-.388.176.536.536 0 0 1-.394-.176L5.47 8.527a.537.537 0 0 1-.164-.407.595.595 0 0 1 .18-.408.541.541 0 0 1 .796 0l.922.959Zm4.766 3.928h.719a.557.557 0 0 1 .563.572.57.57 0 0 1-.162.41.533.533 0 0 1-.4.168h-2.247a.546.546 0 0 1-.403-.165.557.557 0 0 1-.164-.409v-2.296c0-.163.054-.3.16-.412a.53.53 0 0 1 .4-.168c.158 0 .292.056.4.166.11.11.165.246.165.41v1.053a5.008 5.008 0 0 0 1.367-1.708A4.92 4.92 0 0 0 12.875 8c0-1.16-.344-2.185-1.031-3.074-.688-.89-1.557-1.472-2.607-1.747a.657.657 0 0 1-.354-.25.692.692 0 0 1-.133-.415c0-.155.052-.285.156-.391a.38.38 0 0 1 .375-.112c1.365.309 2.492 1.014 3.383 2.116C13.554 5.23 14 6.52 14 8c0 .925-.182 1.78-.547 2.562A6.42 6.42 0 0 1 11.97 12.6Z"
    />
  </svg>
);


export const SparklesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.2}
    className="icon icon-tabler icons-tabler-outline icon-tabler-sparkles"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <path d="M16 18a2 2 0 0 1 2 2 2 2 0 0 1 2-2 2 2 0 0 1-2-2 2 2 0 0 1-2 2zm0-12a2 2 0 0 1 2 2 2 2 0 0 1 2-2 2 2 0 0 1-2-2 2 2 0 0 1-2 2zM9 18a6 6 0 0 1 6-6 6 6 0 0 1-6-6 6 6 0 0 1-6 6 6 6 0 0 1 6 6z" />
  </svg>
)

export const ConfidenceLevelIcon = ({
  line1Color = "#D8D8DB",  
  line2Color = "#D8D8DB",  
  line3Color = "#D8D8DB",  
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      {/* First line */}
      <path
        fill={line1Color}  // Use color passed as line1Color
        d="M4.219 15.784a.735.735 0 0 0 .536.216h1.497c.212 0 .39-.073.533-.219A.723.723 0 0 0 7 15.255V10.75a.72.72 0 0 0-.219-.534.735.735 0 0 0-.536-.216H4.748a.718.718 0 0 0-.533.219.723.723 0 0 0-.215.526v4.505c0 .213.073.39.219.534Z"
      />
      {/* Second line */}
      <path
        fill={line3Color}  // Use color passed as line2Color
        d="M13.755 16a.735.735 0 0 1-.536-.216.72.72 0 0 1-.219-.534V4.75c0-.213.072-.39.215-.534A.723.723 0 0 1 13.748 4h1.497c.212 0 .39.072.536.216A.72.72 0 0 1 16 4.75v10.5c0 .213-.072.39-.215.534a.724.724 0 0 1-.533.216h-1.497Z"
      />
      {/* Third line */}
      <path
        fill={line2Color}  // Use color passed as line3Color
        d="M9.255 16a.736.736 0 0 1-.536-.215.72.72 0 0 1-.219-.535V7.756c0-.212.072-.391.215-.537A.718.718 0 0 1 9.248 7h1.497c.212 0 .39.072.536.215a.72.72 0 0 1 .219.535v7.494a.737.737 0 0 1-.215.537.718.718 0 0 1-.533.219H9.255Z"
      />
    </g>
  </svg>
);

export const HeaderSearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={24} height={24} x={4} y={4} fill="#363699" rx={12} />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m22.75 22.75-4.5-4.5m1.5-3.75a5.251 5.251 0 1 1-10.502 0 5.251 5.251 0 0 1 10.502 0Z"
    />
  </svg>
)

export const ArrowDownSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#1C1B1F"
      d="M7.458 11.502V2.958a.526.526 0 0 1 .538-.541.533.533 0 0 1 .546.54v8.545l3.895-3.896a.548.548 0 0 1 .379-.168.542.542 0 0 1 .4.165c.115.115.17.244.168.387a.543.543 0 0 1-.174.383L8.467 13.11a.688.688 0 0 1-.22.153.644.644 0 0 1-.25.048.644.644 0 0 1-.462-.192L2.793 8.377a.512.512 0 0 1-.166-.387.564.564 0 0 1 .177-.387.568.568 0 0 1 .397-.173c.142 0 .268.057.38.173l3.877 3.899Z"
    />
  </svg>
)

export const FacebookIcon = ({ size = 36, width, height, ...props }) => {
  const gradientId = "gradient-" + Math.random().toString(36).substring(2, 7);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || size}
      height={height || size}
      viewBox="0 0 60 60"
      {...props}
    >
      <linearGradient
        id={gradientId}
        x1={9.993}
        x2={40.615}
        y1={9.993}
        y2={40.615}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#2aa4f4" />
        <stop offset={1} stopColor="#007ad9" />
      </linearGradient>
      <path
        fill={`url(#${gradientId})`}
        d="M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4z"
      />
      <path
        fill="#fff"
        d="M26.707 29.301h5.176l.813-5.258h-5.989v-2.874c0-2.184.714-4.121 2.757-4.121h3.283V12.46c-.577-.078-1.797-.248-4.102-.248-4.814 0-7.636 2.542-7.636 8.334v3.498H16.06v5.258h4.948v14.452c.98.146 1.973.246 2.992.246.921 0 1.82-.084 2.707-.204V29.301z"
      />
    </svg>
  );
};

export const CapterraIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 908 925" 
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    {...props}
  >
    <path
      fill="#67c5ed"
      d="M905.5-.5h2v3a736932.204 736932.204 0 0 1-291 921v-815a74538.178 74538.178 0 0 0 289-109Z"
      style={{
        opacity: 0.997,
      }}
    />
    <path
      fill="#fe9d28"
      d="M616.5 108.5v231h-233c-127.501-.333-254.834 0-382 1h-2v-1a240451.536 240451.536 0 0 1 617-231Z"
      style={{
        opacity: 0.998,
      }}
    />
    <path
      fill="#e44747"
      d="M1.5 340.5c127.166-1 254.499-1.333 382-1 19.673 50.011 39.34 100.011 59 150a57059.662 57059.662 0 0 1-441-149Z"
      style={{
        opacity: 0.994,
      }}
    />
    <path
      fill="#044d80"
      d="M383.5 339.5h233v585h-1a173226.407 173226.407 0 0 0-173-435c-19.66-49.989-39.327-99.989-59-150Z"
      style={{
        opacity: 0.998,
      }}
    />
  </svg>
)

export const ClozdIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 256 256" 
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    {...props}
  >
    <path
      fill="#09d1c6"
      d="M111.5-.5h32a369.418 369.418 0 0 1 20 4.5c1.48 1.3 2.146 2.966 2 5A215.86 215.86 0 0 1 146 67.5c-2.075 2.148-4.408 2.482-7 1-10.769-23.444-26.103-43.444-46-60-.677-2.482.156-4.315 2.5-5.5a738.971 738.971 0 0 1 16-3.5Z"
      style={{
        opacity: 0.973,
      }}
    />
    <path
      fill="#14a4f6"
      d="M65.5 14.5c2.222-.322 4.056.345 5.5 2 12.56 18.116 21.56 37.783 27 59-.804 1.305-1.97 1.971-3.5 2-24.96-8.78-50.626-12.28-77-10.5-1.076-1.726-1.243-3.56-.5-5.5 12.452-19.62 28.619-35.287 48.5-47Z"
      style={{
        opacity: 0.97,
      }}
    />
    <path
      fill="#14a4f6"
      d="M188.5 16.5c1.699-.16 3.366.006 5 .5 20.373 12.537 36.04 29.37 47 50.5-.029 1.53-.696 2.696-2 3.5-18.116 12.56-37.783 21.56-59 27-1.304-.804-1.971-1.97-2-3.5 8.719-25.363 12.385-51.363 11-78Z"
      style={{
        opacity: 0.969,
      }}
    />
    <path
      fill="#1e62e4"
      d="M-.5 143.5v-32a369.311 369.311 0 0 1 4.5-20c1.3-1.48 2.966-2.146 5-2A215.832 215.832 0 0 1 67.5 109c2.148 2.075 2.482 4.408 1 7-23.444 10.769-43.444 26.103-60 46-2.482.677-4.315-.156-5.5-2.5a738.971 738.971 0 0 1-3.5-16Z"
      style={{
        opacity: 0.985,
      }}
    />
    <path
      fill="#1e62e4"
      d="M255.5 111.5v32a369.528 369.528 0 0 1-4.5 20c-1.299 1.48-2.966 2.146-5 2a215.862 215.862 0 0 1-58.5-19.5c-2.148-2.075-2.482-4.408-1-7 23.444-10.769 43.444-26.103 60-46 2.482-.677 4.315.156 5.5 2.5a736.39 736.39 0 0 1 3.5 16Z"
      style={{
        opacity: 0.986,
      }}
    />
    <path
      fill="#14a4f6"
      d="M71.5 156.5c3.364-.627 5.364.706 6 4-8.78 24.961-12.28 50.628-10.5 77a6.29 6.29 0 0 1-3 1c-17.768-9.761-32.435-23.094-44-40a42.507 42.507 0 0 1-5.5-11c.029-1.529.695-2.696 2-3.5 17.31-11.322 35.643-20.488 55-27.5Z"
      style={{
        opacity: 0.97,
      }}
    />
    <path
      fill="#14a4f5"
      d="M158.5 177.5c25.654 8.593 51.988 12.093 79 10.5a6.293 6.293 0 0 1 1 3c-10.474 18.811-24.807 34.145-43 46a42.597 42.597 0 0 1-8 3.5c-1.529-.029-2.696-.696-3.5-2-11.83-17.661-20.996-36.661-27.5-57 .252-1.573.918-2.906 2-4Z"
      style={{
        opacity: 0.97,
      }}
    />
    <path
      fill="#09d2c6"
      d="M143.5 255.5h-32a369.421 369.421 0 0 1-20-4.5c-1.48-1.299-2.146-2.966-2-5a215.834 215.834 0 0 1 19.5-58.5c2.075-2.148 4.408-2.482 7-1 10.769 23.444 26.103 43.444 46 60 .677 2.482-.156 4.315-2.5 5.5a736.39 736.39 0 0 1-16 3.5Z"
      style={{
        opacity: 0.976,
      }}
    />
  </svg>
)

export const WalkmeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    clipRule="evenodd"
    viewBox="0 0 560 400" 
    width={54}
    height={54}
    {...props}
  >
    <path
      fillRule="nonzero"
      d="M170.87 167.891v29.086c0 6.837-1.802 12.239-5.406 16.207s-8.44 5.95-14.512 5.95a19.228 19.228 0 0 1-8.709-1.999 18.907 18.907 0 0 1-6.811-5.747 20.408 20.408 0 0 1-6.943 5.795 18.827 18.827 0 0 1-8.548 1.952c-6.074 0-10.92-1.996-14.535-5.987s-5.418-9.38-5.406-16.166v-29.09h9.004v30.683c0 3.556 1.001 6.422 3.003 8.598s4.65 3.26 7.946 3.257a10.444 10.444 0 0 0 7.977-3.287c2.062-2.187 3.093-5.043 3.093-8.568v-30.684h8.95v30.684c0 3.556 1.001 6.422 3.003 8.598s4.65 3.26 7.946 3.257a10.334 10.334 0 0 0 7.935-3.3c2.034-2.186 3.053-5.042 3.057-8.567v-30.672zM214.867 218.213v-25.086c0-5.265-1.494-9.532-4.481-12.8s-6.864-4.902-11.629-4.898c-4.733 0-8.619 1.616-11.658 4.85s-4.557 7.395-4.553 12.489c0 5.189 1.562 9.447 4.685 12.776s7.104 4.998 11.94 5.005a18.621 18.621 0 0 0 6.404-1.131 24.134 24.134 0 0 0 6.252-3.485v9.693a25.99 25.99 0 0 1-6.51 2.593c-2.35.57-4.76.854-7.178.844a23.939 23.939 0 0 1-7.154-1.102 23.37 23.37 0 0 1-6.433-3.107 25.25 25.25 0 0 1-8.337-9.358 26.97 26.97 0 0 1-2.883-12.495c0-7.54 2.383-13.764 7.148-18.674s10.822-7.362 18.17-7.358a25.135 25.135 0 0 1 13.274 3.64 24.346 24.346 0 0 1 9.273 10.005 22.716 22.716 0 0 1 2.133 6.28c.504 3.369.719 6.773.642 10.178v21.135z"
    />
    <path d="M229.228 144.757h9.058v73.456h-9.058z" />
    <path
      fillRule="nonzero"
      d="M244.418 218.213v-73.456h9.058v41.395h4.012a11.38 11.38 0 0 0 6.307-1.593c1.63-1.061 3.388-3.147 5.274-6.256l6.432-10.412h10.548l-7.406 11.974a35.332 35.332 0 0 1-3.862 5.31 13.255 13.255 0 0 1-3.604 2.994c4.152.799 7.215 2.501 9.19 5.107s2.959 6.31 2.955 11.107v13.83h-9.106V205.49c0-3.592-.799-6.286-2.403-7.975s-4.12-2.532-7.58-2.532h-10.757v23.23z"
    />
    <path
      fill="#0094d4"
      d="M425.572 140.5H323.33c-18.887 0-34.428 15.492-34.428 34.318v33.145c0 18.826 15.541 34.318 34.428 34.318h26.489l24.254 17.219 24.253-17.219h27.246c18.887 0 34.428-15.492 34.428-34.318v-33.139c0-18.828-15.54-34.321-34.428-34.324"
    />
  </svg>
)

export const G2crowdIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
    viewBox="0 0 224 224"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    {...props}
  >
    <path
      fill="#fffdfd"
      d="M-.5-.5h224v224H-.5V-.5Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#ff482b"
      d="M104.5 11.5c60.382 1.932 95.882 32.598 106.5 92 .285 51.29-23.548 85.79-71.5 103.5-49.956 11.254-88.456-4.579-115.5-47.5-20.492-42.925-15.158-82.258 16-118 18.051-17.443 39.551-27.443 64.5-30Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#fffbfb"
      d="M103.5 54.5a80.886 80.886 0 0 1 20 1.5c-3.56 7.49-7.227 14.99-11 22.5-14.186 1.175-24.353 8.175-30.5 21-5.576 21.349 1.924 35.849 22.5 43.5 10.644 2.06 20.31-.106 29-6.5a634.945 634.945 0 0 1 12 20.5c-12.005 9.42-25.672 13.087-41 11-24.76-4.76-40.593-19.26-47.5-43.5-4.64-36.838 10.86-60.171 46.5-70Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#fff8f7"
      d="M138.5 86.5c-.543.06-.876.393-1 1a64.873 64.873 0 0 0 16 1v6h-24v-7a16.455 16.455 0 0 1 4-7.5 252.45 252.45 0 0 0 12.5-8.5c.486-5.492-2.014-7.325-7.5-5.5a32.4 32.4 0 0 0-5 4.5c-4.203-1.921-4.869-4.588-2-8 5.997-4.648 12.33-5.148 19-1.5 4.214 4.2 5.048 9.034 2.5 14.5a313.814 313.814 0 0 0-14.5 11Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#ff8b7a"
      d="m138.5 86.5 16 2h-1a64.873 64.873 0 0 1-16-1c.124-.607.457-.94 1-1Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#ffc8bf"
      d="M129.5 87.5v7h24v-6h1v7h-26c-.306-2.885.027-5.552 1-8Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#fffcfc"
      d="m138.5 128.5-28-2a732.405 732.405 0 0 0 13-22.5 210.395 210.395 0 0 1 29 0 524.62 524.62 0 0 0 14 23.5 435.317 435.317 0 0 1-14.5 24c-4.512-7.694-9.012-15.361-13.5-23Z"
      style={{
        opacity: 1,
      }}
    />
    <path
      fill="#ff6b54"
      d="m110.5 126.5 28 2c-9.69.332-19.356-.002-29-1 .124-.607.457-.94 1-1Z"
      style={{
        opacity: 1,
      }}
    />
  </svg>
)

export const SurgingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="rgba(255, 135, 0, 1)" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="rgba(255, 135, 0, 1)"
        d="M15.157 6.38v8.359c0 .265.09.488.268.668.179.18.4.27.664.27s.488-.09.67-.27a.9.9 0 0 0 .273-.668V4.114a.907.907 0 0 0-.27-.668.907.907 0 0 0-.667-.27H5.47a.91.91 0 0 0-.668.268.9.9 0 0 0-.27.664c0 .264.09.488.27.67a.9.9 0 0 0 .668.273h8.36l-9.897 9.896a.897.897 0 0 0-.286.651c0 .243.095.46.286.651a.912.912 0 0 0 1.328 0l9.896-9.87Z"
      />
    </g>
  </svg>
)

export const PlungingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    fill="rgba(255, 135, 0, 1)"
    {...props}
  >
    <path
      fill="rgba(255, 135, 0, 1)"
      d="M12.157 10.333v-8.36a.91.91 0 0 1 .268-.668.9.9 0 0 1 .664-.27c.264 0 .487.09.67.27a.9.9 0 0 1 .273.668v10.625c0 .266-.09.488-.27.668a.907.907 0 0 1-.667.27H2.47a.91.91 0 0 1-.668-.268.9.9 0 0 1-.27-.664c0-.264.09-.487.27-.67a.9.9 0 0 1 .668-.273h8.36L.932 1.765a.897.897 0 0 1-.286-.651c0-.243.095-.46.286-.651a.911.911 0 0 1 1.328 0l9.896 9.87Z"
    />
  </svg>
)

export const TrendsCalendarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#1C1B1F"
      d="M1.757 12.583c-.375 0-.692-.132-.951-.396a1.3 1.3 0 0 1-.389-.943V3.756c0-.365.13-.68.389-.943.259-.264.576-.396.95-.396h.821V.878a.543.543 0 0 1 .554-.557.549.549 0 0 1 .562.557v1.539H8.34V.862a.526.526 0 0 1 .537-.541c.153 0 .282.051.388.155a.519.519 0 0 1 .158.386v1.555h.82c.376 0 .693.132.952.396a1.3 1.3 0 0 1 .389.943v7.488c0 .365-.13.68-.389.944-.259.263-.576.395-.951.395H1.757Zm0-1.083h8.487a.245.245 0 0 0 .176-.08.245.245 0 0 0 .08-.176V6.256h-9v4.988c0 .064.027.122.08.176.054.053.113.08.177.08ZM1.5 5.173h9V3.756a.245.245 0 0 0-.08-.176.245.245 0 0 0-.176-.08H1.757a.245.245 0 0 0-.177.08.245.245 0 0 0-.08.176v1.417Z"
    />
  </svg>
)
export default CloseIcon

export const RefreshCheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5 4.07119C4.42708 4.534 3.97135 5.1046 3.63281 5.783C3.29427 6.46151 3.125 7.20044 3.125 7.99979C3.125 9.16027 3.46875 10.185 4.15625 11.074C4.84375 11.963 5.71281 12.5451 6.76344 12.8205C6.91073 12.8645 7.02865 12.9511 7.11719 13.0803C7.20573 13.2093 7.25 13.3504 7.25 13.5035C7.25 13.6565 7.19792 13.7836 7.09375 13.8847C6.98958 13.9858 6.86458 14.0204 6.71875 13.9885C5.35417 13.6904 4.22656 12.9877 3.33594 11.8805C2.44531 10.7732 2 9.47967 2 7.99979C2 7.07449 2.18229 6.22031 2.54688 5.43726C2.91146 4.6543 3.40625 3.97537 4.03125 3.40045H3.3125C3.15313 3.40045 3.01953 3.34568 2.91172 3.23612C2.80391 3.12657 2.75 2.99083 2.75 2.82889C2.75 2.66696 2.8038 2.5301 2.91141 2.41831C3.01911 2.30652 3.1525 2.25062 3.31156 2.25062H5.55813C5.71729 2.25062 5.85156 2.30561 5.96094 2.41559C6.07031 2.52568 6.125 2.66201 6.125 2.82458V5.12073C6.125 5.28341 6.07141 5.42065 5.96422 5.53244C5.85703 5.64423 5.72422 5.70012 5.56578 5.70012C5.40734 5.70012 5.27344 5.64503 5.16406 5.53483C5.05469 5.42464 5 5.2881 5 5.1252V4.07119ZM7.20312 8.67052L9.73438 6.09937C9.84896 5.98226 9.97917 5.9237 10.125 5.9237C10.2708 5.9237 10.4035 5.98226 10.5231 6.09937C10.6327 6.21648 10.6875 6.35223 10.6875 6.5066C10.6875 6.66098 10.6302 6.79672 10.5156 6.91383L7.59375 9.90021C7.48292 10.0173 7.35365 10.0759 7.20594 10.0759C7.05823 10.0759 6.92708 10.0173 6.8125 9.90021L5.46875 8.52679C5.35417 8.40968 5.29948 8.27394 5.30469 8.11956C5.3099 7.96519 5.36979 7.82944 5.48438 7.71233C5.59896 7.59522 5.73177 7.53666 5.88281 7.53666C6.03385 7.53666 6.16667 7.59522 6.28125 7.71233L7.20312 8.67052ZM11.9688 12.5991H12.6875C12.8469 12.5991 12.9805 12.6539 13.0883 12.7635C13.1961 12.873 13.25 13.0087 13.25 13.1707C13.25 13.3326 13.1962 13.4695 13.0886 13.5813C12.9809 13.6931 12.8475 13.749 12.6884 13.749H10.4419C10.2827 13.749 10.1484 13.694 10.0391 13.584C9.92969 13.4739 9.875 13.3376 9.875 13.175V10.8788C9.875 10.7162 9.92859 10.5789 10.0358 10.4671C10.143 10.3553 10.2758 10.2995 10.4342 10.2995C10.5927 10.2995 10.7266 10.3546 10.8359 10.4647C10.9453 10.5749 11 10.7115 11 10.8744V11.9284C11.5729 11.4706 12.0286 10.901 12.3672 10.2196C12.7057 9.53822 12.875 8.79828 12.875 7.99979C12.875 6.83931 12.5312 5.81457 11.8438 4.92558C11.1562 4.03659 10.2872 3.45443 9.23656 3.17911C9.08927 3.13504 8.97135 3.05178 8.88281 2.92934C8.79427 2.80691 8.75 2.66839 8.75 2.51381C8.75 2.35922 8.80208 2.2288 8.90625 2.12254C9.01042 2.01629 9.13542 1.97913 9.28125 2.01107C10.6458 2.31982 11.7734 3.02516 12.6641 4.12709C13.5547 5.22901 14 6.51991 14 7.99979C14 8.92508 13.8177 9.77926 13.4531 10.5623C13.0885 11.3453 12.5938 12.0242 11.9688 12.5991Z"
      fill= {props.color ? props.color:  "#1C1B1F"}
    />
  </svg>
);

export const VerifiedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M8.12518 9.88793L6.77268 8.54814C6.65726 8.43272 6.51434 8.37369 6.34393 8.37106C6.17351 8.36842 6.02365 8.43168 5.89434 8.56085C5.77365 8.68168 5.7133 8.82807 5.7133 9.00001C5.7133 9.17196 5.77365 9.31835 5.89434 9.43918L7.59788 11.1427C7.74858 11.2933 7.92434 11.3686 8.12518 11.3686C8.32601 11.3686 8.50177 11.2933 8.65247 11.1427L12.106 7.68918C12.2299 7.56515 12.291 7.42008 12.2893 7.25397C12.2878 7.08786 12.2267 6.94015 12.106 6.81085C11.9767 6.68168 11.8282 6.61494 11.6604 6.61064C11.4927 6.60633 11.3443 6.66883 11.215 6.79814L8.12518 9.88793ZM6.0083 16.6523L4.85601 14.7148L2.67643 14.2467C2.48948 14.2104 2.34018 14.1122 2.22851 13.9519C2.11684 13.7916 2.07226 13.618 2.09476 13.4311L2.30788 11.1892L0.825593 9.49356C0.697398 9.35689 0.633301 9.19237 0.633301 9.00001C0.633301 8.80765 0.697398 8.64314 0.825593 8.50647L2.30788 6.81085L2.09476 4.56897C2.07226 4.38203 2.11684 4.20842 2.22851 4.04814C2.34018 3.88786 2.48948 3.7896 2.67643 3.75335L4.85601 3.28522L6.0083 1.34772C6.10872 1.18328 6.24545 1.07112 6.41851 1.01126C6.59156 0.951402 6.76733 0.960499 6.9458 1.03855L9.00018 1.9071L11.0546 1.03855C11.233 0.960499 11.4088 0.951402 11.5818 1.01126C11.7549 1.07112 11.8916 1.18328 11.9921 1.34772L13.1443 3.28522L15.3239 3.75335C15.5109 3.7896 15.6602 3.88786 15.7718 4.04814C15.8835 4.20842 15.9281 4.38203 15.9056 4.56897L15.6925 6.81085L17.1748 8.50647C17.303 8.64314 17.3671 8.80765 17.3671 9.00001C17.3671 9.19237 17.303 9.35689 17.1748 9.49356L15.6925 11.1892L15.9056 13.4311C15.9281 13.618 15.8835 13.7916 15.7718 13.9519C15.6602 14.1122 15.5109 14.2104 15.3239 14.2467L13.1443 14.7148L11.9921 16.6523C11.8916 16.8167 11.7549 16.9289 11.5818 16.9888C11.4088 17.0486 11.233 17.0395 11.0546 16.9615L9.00018 16.0929L6.9458 16.9615C6.76733 17.0395 6.59156 17.0486 6.41851 16.9888C6.24545 16.9289 6.10872 16.8167 6.0083 16.6523Z"
      fill="black"
    />
  </svg>
);

export const ValidateIdeaIcon = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.15 7.70006L5.15 6.71673C5.02778 6.59451 4.88889 6.53339 4.73333 6.53339C4.57778 6.53339 4.43889 6.59451 4.31667 6.71673C4.19444 6.83895 4.13333 6.98062 4.13333 7.14173C4.13333 7.30284 4.19444 7.44451 4.31667 7.56673L5.73333 8.98339C5.85556 9.10562 5.99444 9.16673 6.15 9.16673C6.30556 9.16673 6.44444 9.10562 6.56667 8.98339L9.68333 5.86673C9.80556 5.74451 9.86667 5.60284 9.86667 5.44173C9.86667 5.28062 9.80556 5.13895 9.68333 5.01673C9.56111 4.89451 9.42222 4.83339 9.26667 4.83339C9.11111 4.83339 8.97222 4.89451 8.85 5.01673L6.15 7.70006ZM4.51667 13.3501L3.53333 11.7334L1.7 11.3167C1.54444 11.2834 1.42222 11.2084 1.33333 11.0917C1.24444 10.9751 1.21111 10.839 1.23333 10.6834L1.4 8.80006L0.15 7.40006C0.05 7.27784 0 7.14451 0 7.00006C0 6.85562 0.05 6.72228 0.15 6.60006L1.4 5.20006L1.23333 3.31673C1.21111 3.16117 1.24444 3.02506 1.33333 2.90839C1.42222 2.79173 1.54444 2.71673 1.7 2.68339L3.53333 2.26673L4.51667 0.650061C4.59444 0.527839 4.70278 0.441727 4.84167 0.391727C4.98056 0.341727 5.12222 0.344505 5.26667 0.400061L7 1.15006L8.73333 0.400061C8.87778 0.344505 9.01944 0.341727 9.15833 0.391727C9.29722 0.441727 9.40556 0.527839 9.48333 0.650061L10.4667 2.26673L12.3 2.68339C12.4556 2.71673 12.5778 2.79173 12.6667 2.90839C12.7556 3.02506 12.7889 3.16117 12.7667 3.31673L12.6 5.20006L13.85 6.60006C13.95 6.72228 14 6.85562 14 7.00006C14 7.14451 13.95 7.27784 13.85 7.40006L12.6 8.80006L12.7667 10.6834C12.7889 10.839 12.7556 10.9751 12.6667 11.0917C12.5778 11.2084 12.4556 11.2834 12.3 11.3167L10.4667 11.7334L9.48333 13.3501C9.40556 13.4723 9.29722 13.5584 9.15833 13.6084C9.01944 13.6584 8.87778 13.6556 8.73333 13.6001L7 12.8501L5.26667 13.6001C5.12222 13.6556 4.98056 13.6584 4.84167 13.6084C4.70278 13.5584 4.59444 13.4723 4.51667 13.3501ZM5.26667 12.2834L7 11.5501L8.73333 12.2834L9.7 10.6667L11.5333 10.2501L11.3667 8.40006L12.6 7.00006L11.3667 5.60006L11.5333 3.75006L9.7 3.33339L8.73333 1.71673L7 2.45006L5.26667 1.71673L4.3 3.33339L2.46667 3.73339L2.63333 5.60006L1.4 7.00006L2.65 8.40006L2.46667 10.2667L4.3 10.6834L5.26667 12.2834Z" fill="#4B4BE8"/>
  </svg>
);
export const BagelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="146"
    height="146"
    viewBox="0 0 146 146"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 73C0.5 32.9594 32.9594 0.5 73 0.5C113.041 0.5 145.5 32.9594 145.5 73C145.5 113.041 113.041 145.5 73 145.5C32.9594 145.5 0.5 113.041 0.5 73ZM73 48.8333C59.6531 48.8333 48.8333 59.6531 48.8333 73C48.8333 86.3469 59.6531 97.1667 73 97.1667C86.3469 97.1667 97.1667 86.3469 97.1667 73C97.1667 59.6531 86.3469 48.8333 73 48.8333ZM97.407 25.5201C98.8373 23.2663 101.824 22.5987 104.078 24.0291C112.326 29.2638 119.119 36.4973 123.826 45.0584C128.532 53.6194 131 63.2306 131 73.0001C131 75.6695 128.836 77.8334 126.166 77.8334C123.497 77.8334 121.333 75.6695 121.333 73.0001C121.333 64.8588 119.277 56.8495 115.355 49.7153C111.433 42.5811 105.772 36.5532 98.8981 32.1909C96.6442 30.7606 95.9767 27.774 97.407 25.5201ZM82.0869 15.7163C78.485 15.1449 74.8372 14.9145 71.1921 15.0282C68.524 15.1114 66.4285 17.3418 66.5117 20.0098C66.5949 22.6779 68.8253 24.7734 71.4934 24.6902C74.531 24.5954 77.5708 24.7874 80.5724 25.2635C83.2088 25.6818 85.6851 23.8836 86.1033 21.2471C86.5215 18.6107 84.7233 16.1345 82.0869 15.7163Z"
      fill="white"
      fill-opacity="0.5"
    />
  </svg>
);
export const BagelIcon80 = (props) => (
  <svg width="145" height="145" viewBox="0 0 145 145" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 72.5C0 32.4594 32.4594 0 72.5 0C112.541 0 145 32.4594 145 72.5C145 112.541 112.541 145 72.5 145C32.4594 145 0 112.541 0 72.5ZM72.5 48.3333C59.1531 48.3333 48.3333 59.1531 48.3333 72.5C48.3333 85.8469 59.1531 96.6667 72.5 96.6667C85.8469 96.6667 96.6667 85.8469 96.6667 72.5C96.6667 59.1531 85.8469 48.3333 72.5 48.3333ZM96.907 25.0201C98.3373 22.7663 101.324 22.0987 103.578 23.5291C111.826 28.7638 118.619 35.9973 123.326 44.5584C128.032 53.1194 130.5 62.7306 130.5 72.5001C130.5 75.1695 128.336 77.3334 125.666 77.3334C122.997 77.3334 120.833 75.1695 120.833 72.5001C120.833 64.3588 118.777 56.3495 114.855 49.2153C110.933 42.0811 105.272 36.0532 98.3981 31.6909C96.1442 30.2606 95.4767 27.274 96.907 25.0201ZM81.5869 15.2163C77.985 14.6449 74.3372 14.4145 70.6921 14.5282C68.024 14.6114 65.9285 16.8418 66.0117 19.5098C66.0949 22.1779 68.3253 24.2734 70.9934 24.1902C74.031 24.0954 77.0708 24.2874 80.0724 24.7635C82.7088 25.1818 85.1851 23.3836 85.6033 20.7471C86.0215 18.1107 84.2233 15.6345 81.5869 15.2163Z" fill="#8D8DF1"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M14.3541 29.1878C5.3377 41.2726 0 56.263 0 72.5001C0 112.541 32.4594 145 72.5 145C112.541 145 145 112.541 145 72.5001C145 70.8865 144.947 69.2853 144.843 67.698L132 40.5C130.191 43.161 126.661 43.2102 122.033 42.3264C122.48 43.0598 122.911 43.804 123.326 44.5584C128.032 53.1195 130.5 62.7307 130.5 72.5001C130.5 75.1695 128.336 77.3335 125.666 77.3335C122.997 77.3335 120.833 75.1695 120.833 72.5001C120.833 64.3589 118.777 56.3496 114.855 49.2154C112.774 45.4302 110.203 41.9565 107.222 38.8777C103.777 38.2026 100.161 37.7143 96.4865 37.7143C86.8197 37.7143 78.702 33.9175 70.2716 29.9744C61.1657 25.7154 51.6951 21.2858 39.5135 21.2858C28.581 21.2858 20.1504 25.0022 14.3541 29.1878ZM48.3333 72.5001C48.3333 59.1532 59.1531 48.3334 72.5 48.3334C85.8469 48.3334 96.6667 59.1532 96.6667 72.5001C96.6667 85.8469 85.8469 96.6667 72.5 96.6667C59.1531 96.6667 48.3333 85.8469 48.3333 72.5001Z" fill="#C6C6F8"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M14.7444 28.6696C5.49192 40.8428 0 56.0301 0 72.5001C0 112.541 32.4594 145 72.5 145C112.541 145 145 112.541 145 72.5001C145 59.7773 141.723 47.82 135.967 37.4263C129.461 33.4762 119.736 29.437 109.598 27.916C115.157 32.5421 119.82 38.182 123.326 44.5584C128.032 53.1195 130.5 62.7307 130.5 72.5001C130.5 75.1695 128.336 77.3335 125.666 77.3335C122.997 77.3335 120.833 75.1695 120.833 72.5001C120.833 64.3589 118.777 56.3496 114.855 49.2154C110.933 42.0812 105.272 36.0532 98.3981 31.6909C96.9374 30.764 96.1429 29.1833 96.1541 27.572C86.4578 28.6175 78.4615 32.3575 70.7284 35.9744C62.298 39.9175 54.1803 43.7143 44.5135 43.7143C31.7054 43.7143 20.8801 35.3825 14.7444 28.6696ZM48.3333 72.5001C48.3333 59.1532 59.1531 48.3334 72.5 48.3334C85.8469 48.3334 96.6667 59.1532 96.6667 72.5001C96.6667 85.8469 85.8469 96.6667 72.5 96.6667C59.1531 96.6667 48.3333 85.8469 48.3333 72.5001Z" fill="white"/>
  </svg>
);

export const BagelIcon100 = (props) => (
  <svg width="145" height="145" viewBox="0 0 145 145" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 72.5002C0 32.4596 32.4594 0.000244141 72.5 0.000244141C112.541 0.000244141 145 32.4596 145 72.5002C145 112.541 112.541 145 72.5 145C32.4594 145 0 112.541 0 72.5002ZM72.5 48.3336C59.1531 48.3336 48.3333 59.1534 48.3333 72.5002C48.3333 85.8471 59.1531 96.6669 72.5 96.6669C85.8469 96.6669 96.6667 85.8471 96.6667 72.5002C96.6667 59.1534 85.8469 48.3336 72.5 48.3336ZM96.907 25.0204C98.3373 22.7666 101.324 22.099 103.578 23.5293C111.826 28.764 118.619 35.9976 123.326 44.5586C128.032 53.1197 130.5 62.7309 130.5 72.5003C130.5 75.1697 128.336 77.3337 125.666 77.3337C122.997 77.3337 120.833 75.1697 120.833 72.5003C120.833 64.3591 118.777 56.3498 114.855 49.2156C110.933 42.0813 105.272 36.0534 98.3981 31.6911C96.1442 30.2608 95.4767 27.2742 96.907 25.0204ZM81.5869 15.2165C77.985 14.6451 74.3372 14.4148 70.6921 14.5284C68.024 14.6116 65.9285 16.842 66.0117 19.5101C66.0949 22.1782 68.3253 24.2736 70.9934 24.1904C74.031 24.0957 77.0708 24.2876 80.0724 24.7638C82.7088 25.182 85.1851 23.3838 85.6033 20.7474C86.0215 18.111 84.2233 15.6347 81.5869 15.2165Z" fill="white"/>
  </svg>
);

export const BagelIcon20 = (props) => (
  <svg width="145" height="145" viewBox="0 0 145 145" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 72.5C0 32.4594 32.4594 0 72.5 0C112.541 0 145 32.4594 145 72.5C145 112.541 112.541 145 72.5 145C32.4594 145 0 112.541 0 72.5ZM72.5 48.3333C59.1531 48.3333 48.3333 59.1531 48.3333 72.5C48.3333 85.8469 59.1531 96.6667 72.5 96.6667C85.8469 96.6667 96.6667 85.8469 96.6667 72.5C96.6667 59.1531 85.8469 48.3333 72.5 48.3333ZM96.907 25.0201C98.3373 22.7663 101.324 22.0987 103.578 23.5291C111.826 28.7638 118.619 35.9973 123.326 44.5584C128.032 53.1194 130.5 62.7306 130.5 72.5001C130.5 75.1695 128.336 77.3334 125.666 77.3334C122.997 77.3334 120.833 75.1695 120.833 72.5001C120.833 64.3588 118.777 56.3495 114.855 49.2153C110.933 42.0811 105.272 36.0532 98.3981 31.6909C96.1442 30.2606 95.4767 27.274 96.907 25.0201ZM81.5869 15.2163C77.985 14.6449 74.3372 14.4145 70.6921 14.5282C68.024 14.6114 65.9285 16.8418 66.0117 19.5098C66.0949 22.1779 68.3253 24.2734 70.9934 24.1902C74.031 24.0954 77.0708 24.2874 80.0724 24.7635C82.7088 25.1818 85.1851 23.3836 85.6033 20.7471C86.0215 18.1107 84.2233 15.6345 81.5869 15.2163Z" fill="#8D8DF1"/>
    <path d="M134.517 110.072C121.805 131.011 98.786 145 72.5 145C48.6479 145 27.486 133.482 14.2733 115.704C20.5506 111.313 29.9187 107.286 42.2162 107.286C55.3802 107.286 65.6146 111.715 75.4548 115.974C84.5651 119.918 93.3374 123.714 103.784 123.714C116.675 123.714 127.707 116.487 134.517 110.072Z" fill="#C6C6F8"/>
    <path d="M134.206 110.579C121.431 131.237 98.573 145 72.5 145C42.2929 145 16.4006 126.526 5.50476 100.26C11.9555 107.921 24.9458 118.857 40.5676 118.857C51.4037 118.857 60.5034 114.648 69.9536 110.276C80.161 105.554 90.7773 100.643 104.432 100.643C117.714 100.643 127.702 105.483 134.206 110.579Z" fill="white"/>
  </svg>
)

export const BagelIcon40 = (props) => (
  <svg width="145" height="145" viewBox="0 0 145 145" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 72.5C0 32.4594 32.4594 0 72.5 0C112.541 0 145 32.4594 145 72.5C145 112.541 112.541 145 72.5 145C32.4594 145 0 112.541 0 72.5ZM72.5 48.3333C59.1531 48.3333 48.3333 59.1531 48.3333 72.5C48.3333 85.8469 59.1531 96.6667 72.5 96.6667C85.8469 96.6667 96.6667 85.8469 96.6667 72.5C96.6667 59.1531 85.8469 48.3333 72.5 48.3333ZM96.907 25.0201C98.3373 22.7663 101.324 22.0987 103.578 23.5291C111.826 28.7638 118.619 35.9973 123.326 44.5584C128.032 53.1194 130.5 62.7306 130.5 72.5001C130.5 75.1695 128.336 77.3334 125.666 77.3334C122.997 77.3334 120.833 75.1695 120.833 72.5001C120.833 64.3588 118.777 56.3495 114.855 49.2153C110.933 42.0811 105.272 36.0532 98.3981 31.6909C96.1442 30.2606 95.4767 27.274 96.907 25.0201ZM81.5869 15.2163C77.985 14.6449 74.3372 14.4145 70.6921 14.5282C68.024 14.6114 65.9285 16.8418 66.0117 19.5098C66.0949 22.1779 68.3253 24.2734 70.9934 24.1902C74.031 24.0954 77.0708 24.2874 80.0724 24.7635C82.7088 25.1818 85.1851 23.3836 85.6033 20.7471C86.0215 18.1107 84.2233 15.6345 81.5869 15.2163Z" fill="#8D8DF1"/>
    <path d="M48.5946 68.9338C48.4225 70.0976 48.3333 71.2884 48.3333 72.5C48.3333 85.8469 59.1531 96.6667 72.5 96.6667C81.8766 96.6667 90.006 91.3266 94.0127 83.5217C98.6783 84.7734 103.517 85.5714 108.73 85.5714C124.22 85.5714 127.296 86.7643 134.643 79.7366C131.012 116.38 110.098 135 72.5 135C39.351 135 11.3981 112.753 2.75787 82.3743C8.75666 76.4157 21.4176 68.4286 40.2703 68.4286C43.1652 68.4286 45.9327 68.6094 48.5946 68.9338Z" fill="#C6C6F8"/>
    <path d="M144.694 79.2023C141.312 116.101 110.281 145 72.5 145C32.4752 145 0.0256852 112.566 0 72.5476V72.4525C0.000722437 71.3269 0.0270955 70.2073 0.0785662 69.0942C5.84435 75.9819 22.2989 89.5714 42.7027 89.5714C46.7597 89.5714 50.6025 89.1416 54.316 88.4181C58.7456 93.4741 65.2499 96.6667 72.5 96.6667C85.1044 96.6667 95.4551 87.0172 96.5676 74.7025C102.312 73.3227 108.471 72.4286 115.297 72.4286C117.203 72.4286 119.049 72.5012 120.835 72.6376C120.908 75.2434 123.043 77.3334 125.666 77.3334C127.803 77.3334 129.616 75.9469 130.254 74.0244C135.863 75.2687 140.683 77.1293 144.694 79.2023Z" fill="white"/>
  </svg>
);

export const BagelIcon60 = (props) => (
  <svg width="145" height="145" viewBox="0 0 145 145" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 72.5C0 32.4594 32.4594 0 72.5 0C112.541 0 145 32.4594 145 72.5C145 112.541 112.541 145 72.5 145C32.4594 145 0 112.541 0 72.5ZM72.5 48.3333C59.1531 48.3333 48.3333 59.1531 48.3333 72.5C48.3333 85.8469 59.1531 96.6667 72.5 96.6667C85.8469 96.6667 96.6667 85.8469 96.6667 72.5C96.6667 59.1531 85.8469 48.3333 72.5 48.3333ZM96.907 25.0201C98.3373 22.7663 101.324 22.0987 103.578 23.5291C111.826 28.7638 118.619 35.9973 123.326 44.5584C128.032 53.1194 130.5 62.7306 130.5 72.5001C130.5 75.1695 128.336 77.3334 125.666 77.3334C122.997 77.3334 120.833 75.1695 120.833 72.5001C120.833 64.3588 118.777 56.3495 114.855 49.2153C110.933 42.0811 105.272 36.0532 98.3981 31.6909C96.1442 30.2606 95.4767 27.274 96.907 25.0201ZM81.5869 15.2163C77.985 14.6449 74.3372 14.4145 70.6921 14.5282C68.024 14.6114 65.9285 16.8418 66.0117 19.5098C66.0949 22.1779 68.3253 24.2734 70.9934 24.1902C74.031 24.0954 77.0708 24.2874 80.0724 24.7635C82.7088 25.1818 85.1851 23.3836 85.6033 20.7471C86.0215 18.1107 84.2233 15.6345 81.5869 15.2163Z" fill="#8D8DF1"/>
    <path d="M7.57888 40.1918C2.72838 49.9198 0 60.8912 0 72.5C0 112.541 32.4594 145 72.5 145C112.541 145 145 112.541 145 72.5C145 65.9614 144.134 59.6249 142.512 53.599C137.662 49.104 130.054 43.8156 120.95 40.6168C121.792 41.896 122.585 43.2107 123.326 44.5583C128.032 53.1194 130.5 62.7306 130.5 72.5C130.5 75.1694 128.336 77.3334 125.666 77.3334C122.997 77.3334 120.833 75.1694 120.833 72.5C120.833 64.3588 118.777 56.3495 114.855 49.2153C112.513 44.955 109.55 41.0892 106.08 37.7371C105.609 37.7219 105.137 37.7142 104.662 37.7142C90.9088 37.7142 80.2161 42.7217 69.9353 47.5362C68.8689 48.0356 67.8069 48.533 66.7463 49.0224C68.5903 48.5721 70.5173 48.3333 72.5 48.3333C85.8469 48.3333 96.6667 59.1531 96.6667 72.5C96.6667 85.8468 85.8469 96.6666 72.5 96.6666C59.1531 96.6666 48.3333 85.8468 48.3333 72.5C48.3333 64.0181 52.703 56.5567 59.3139 52.2443C53.3306 54.6 47.1776 56.2857 40.3378 56.2857C26.4521 56.2857 14.6306 47.6012 7.57888 40.1918Z" fill="#C6C6F8"/>
    <path d="M0.728998 62.1794C0.248556 65.5504 0 68.9962 0 72.5001C0 112.541 32.4594 145 72.5 145C112.541 145 145 112.541 145 72.5001C145 61.9298 142.738 51.8879 138.671 42.832C136.169 46.0906 132.305 50.202 127.431 53.8825C129.456 59.8578 130.5 66.1455 130.5 72.5001C130.5 75.1695 128.336 77.3335 125.666 77.3335C122.997 77.3335 120.833 75.1695 120.833 72.5001C120.833 67.9646 120.195 63.47 118.951 59.1448C113.899 61.6288 108.228 63.2858 102.162 63.2858C99.5333 63.2858 97.006 63.0368 94.5507 62.5964C95.9103 65.6188 96.6667 68.9711 96.6667 72.5001C96.6667 85.8469 85.8469 96.6667 72.5 96.6667C59.1531 96.6667 48.3333 85.8469 48.3333 72.5001C48.3333 62.5102 54.3949 53.936 63.0406 50.2549C55.5291 47.1488 47.4275 44.7143 37.8378 44.7143C17.847 44.7143 5.2656 55.7344 0.728998 62.1794Z" fill="white"/>
  </svg>
);

export const ProgressIcon20 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle
      cx="8.75"
      cy="8.75"
      r="8.75"
      transform="matrix(-1 0 0 1 18.75 1.25)"
      stroke="#E17701"
      stroke-width="2"
    />
    <path
      d="M18.75 10C18.75 5.16751 14.8325 1.25 10 1.25"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);


export const ProgressIcon40 = (props) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.75" cy="8.75" r="8.75" transform="matrix(-1 0 0 1 18.75 1.75)" stroke="#E17701" stroke-width="2"/>
    <path d="M10 1.74999C11.8478 1.74999 13.6482 2.33497 15.1431 3.42109C16.638 4.50721 17.7507 6.03871 18.3217 7.79609C18.8928 9.55347 18.8928 11.4465 18.3217 13.2039C17.7507 14.9613 16.638 16.4928 15.1431 17.5789" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
);


export const ProgressIcon60 = (props) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.75" cy="8.75" r="8.75" transform="matrix(-1 0 0 1 18.75 1.75)" stroke="#E17701" stroke-width="2"/>
    <path d="M10 1.75C11.3808 1.75 12.7421 2.0768 13.9724 2.70369C15.2028 3.33058 16.2673 4.23975 17.0789 5.35688C17.8905 6.474 18.4263 7.76736 18.6423 9.1312C18.8583 10.495 18.7484 11.8906 18.3217 13.2039C17.895 14.5172 17.1636 15.7108 16.1872 16.6872C15.2108 17.6636 14.0172 18.395 12.7039 18.8217C11.3906 19.2484 9.99504 19.3583 8.6312 19.1423C7.26736 18.9263 5.974 18.3905 4.85688 17.5789" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
);


export const ProgressIcon80 = (props) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.75" cy="8.75" r="8.75" transform="matrix(-1 0 0 1 18.75 1.75)" stroke="#E17701" stroke-width="2"/>
    <path d="M10 1.75C11.8478 1.75 13.6482 2.33498 15.1431 3.4211C16.638 4.50722 17.7507 6.03872 18.3217 7.7961C18.8928 9.55348 18.8928 11.4465 18.3217 13.2039C17.7507 14.9613 16.638 16.4928 15.1431 17.5789C13.6482 18.665 11.8478 19.25 10 19.25C8.15218 19.25 6.35179 18.665 4.85688 17.5789C3.36196 16.4928 2.24926 14.9613 1.67826 13.2039C1.10725 11.4465 1.10725 9.55348 1.67826 7.7961" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
);


export const MegaPhone = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={props.fill}>
    <path d="M7.63636 14.7959H6.09091C5.24091 14.7959 4.51326 14.4922 3.90795 13.8847C3.30265 13.2772 3 12.5469 3 11.6939V8.59184C3 7.73878 3.30265 7.0085 3.90795 6.40102C4.51326 5.79354 5.24091 5.4898 6.09091 5.4898H12.2727L17.6432 2.23265C18.1583 1.92245 18.6799 1.92245 19.208 2.23265C19.736 2.54286 20 2.99524 20 3.5898V16.6959C20 17.2905 19.736 17.7429 19.208 18.0531C18.6799 18.3633 18.1583 18.3633 17.6432 18.0531L12.2727 14.7959H10.7273V19.449C10.7273 19.8884 10.5792 20.2568 10.283 20.5541C9.98674 20.8514 9.6197 21 9.18182 21C8.74394 21 8.37689 20.8514 8.08068 20.5541C7.78447 20.2568 7.63636 19.8884 7.63636 19.449V14.7959Z" fill={props.fill}/>
  </svg>
)

export const AssignNewideaIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75642 13.5834C3.38128 13.5834 3.0642 13.4539 2.80517 13.1949C2.54614 12.9358 2.41663 12.6188 2.41663 12.2436V3.75654C2.41663 3.3814 2.54614 3.06432 2.80517 2.80529C3.0642 2.54626 3.38128 2.41675 3.75642 2.41675H6.79808C6.95156 2.41675 7.08017 2.46828 7.18392 2.57133C7.28781 2.67439 7.33975 2.80203 7.33975 2.95425C7.33975 3.10661 7.28781 3.23564 7.18392 3.34133C7.08017 3.44716 6.95156 3.50008 6.79808 3.50008H3.75642C3.69225 3.50008 3.6335 3.52682 3.58017 3.58029C3.5267 3.63362 3.49996 3.69237 3.49996 3.75654V12.2436C3.49996 12.3078 3.5267 12.3665 3.58017 12.4199C3.6335 12.4733 3.69225 12.5001 3.75642 12.5001H12.2435C12.3077 12.5001 12.3664 12.4733 12.4198 12.4199C12.4732 12.3665 12.5 12.3078 12.5 12.2436V9.20196C12.5 9.04848 12.5515 8.91987 12.6545 8.81612C12.7576 8.71223 12.8852 8.66029 13.0375 8.66029C13.1898 8.66029 13.3188 8.71223 13.4245 8.81612C13.5304 8.91987 13.5833 9.04848 13.5833 9.20196V12.2436C13.5833 12.6188 13.4538 12.9358 13.1948 13.1949C12.9357 13.4539 12.6186 13.5834 12.2435 13.5834H3.75642ZM10.25 5.74487H8.54163C8.38815 5.74487 8.25947 5.69279 8.15558 5.58862C8.05183 5.48432 7.99996 5.35585 7.99996 5.20321C7.99996 5.05057 8.05183 4.92272 8.15558 4.81967C8.25947 4.71661 8.38815 4.66508 8.54163 4.66508H10.25V2.96321C10.25 2.81071 10.3015 2.68154 10.4045 2.57571C10.5076 2.46973 10.6352 2.41675 10.7875 2.41675C10.9398 2.41675 11.068 2.46869 11.172 2.57258C11.2761 2.67633 11.3281 2.80494 11.3281 2.95841V4.66675H13.04C13.1938 4.66675 13.3229 4.71869 13.427 4.82258C13.5312 4.92647 13.5833 5.05515 13.5833 5.20862C13.5833 5.36223 13.5312 5.49085 13.427 5.59446C13.3229 5.69821 13.1938 5.75008 13.04 5.75008H11.3281V7.45842C11.3281 7.61189 11.2759 7.74057 11.1716 7.84446C11.0675 7.94821 10.9407 8.00008 10.7914 8.00008C10.6378 8.00008 10.5092 7.948 10.4056 7.84383C10.3018 7.73967 10.25 7.61064 10.25 7.45675V5.74487Z" fill="#1C1B1F"/>
  </svg>

);

export const CustomersDashboardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#5C5CEB"
      d="M4.903 17.917a2.717 2.717 0 0 1-1.994-.826 2.715 2.715 0 0 1-.826-1.993c0-.778.275-1.443.826-1.994a2.714 2.714 0 0 1 1.993-.826c.778 0 1.443.275 1.994.826.55.55.826 1.215.826 1.993a2.78 2.78 0 0 1-.555 1.674v-.424c.444.2.907.349 1.389.448.48.1.962.15 1.444.15 1.806 0 3.367-.598 4.681-1.792 1.315-1.195 2.057-2.674 2.229-4.438a.908.908 0 0 1 .236-.507.642.642 0 0 1 .49-.208.66.66 0 0 1 .497.208.616.616 0 0 1 .172.507c-.185 2.14-1.067 3.944-2.645 5.414-1.579 1.47-3.466 2.204-5.662 2.204a8.26 8.26 0 0 1-1.866-.211 8.658 8.658 0 0 1-1.778-.622 2.726 2.726 0 0 1-1.451.417Zm0-1.39a1.38 1.38 0 0 0 1.013-.416 1.38 1.38 0 0 0 .417-1.014c0-.397-.139-.735-.417-1.013a1.38 1.38 0 0 0-1.013-.417c-.398 0-.736.139-1.014.417a1.38 1.38 0 0 0-.417 1.013c0 .398.14.736.417 1.014a1.38 1.38 0 0 0 1.014.417ZM10 3.057c-1.806 0-3.367.597-4.681 1.791C4.004 6.042 3.262 7.521 3.09 9.285a.907.907 0 0 1-.236.507.642.642 0 0 1-.49.208.66.66 0 0 1-.497-.208.616.616 0 0 1-.173-.507C1.88 7.146 2.762 5.342 4.34 3.872c1.579-1.47 3.466-2.205 5.661-2.205.634 0 1.256.07 1.867.212a8.66 8.66 0 0 1 1.778.621 2.77 2.77 0 0 1 1.451-.403c.775 0 1.436.275 1.984.823.548.548.822 1.21.822 1.986a2.72 2.72 0 0 1-.823 1.99 2.7 2.7 0 0 1-1.986.826c-.776 0-1.439-.275-1.99-.825a2.715 2.715 0 0 1-.826-1.994 2.78 2.78 0 0 1 .555-1.674v.424a6.715 6.715 0 0 0-1.389-.448c-.481-.1-.963-.15-1.444-.15Zm5.097 3.277c.394 0 .728-.139 1.004-.417.275-.278.413-.616.413-1.013 0-.394-.138-.728-.413-1.004a1.365 1.365 0 0 0-1.004-.413c-.393 0-.73.138-1.01.413-.28.276-.42.61-.42 1.004 0 .393.139.73.417 1.01.278.28.616.42 1.013.42Z"
    />
    <path
      fill="#5C5CEB"
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
      opacity={0.2}
    />
    <path
      stroke="#5C5CEB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
    />
  </svg>
)

export const CustomersDashboardIconNotChosen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="black"
      d="M4.903 17.917a2.717 2.717 0 0 1-1.994-.826 2.715 2.715 0 0 1-.826-1.993c0-.778.275-1.443.826-1.994a2.714 2.714 0 0 1 1.993-.826c.778 0 1.443.275 1.994.826.55.55.826 1.215.826 1.993a2.78 2.78 0 0 1-.555 1.674v-.424c.444.2.907.349 1.389.448.48.1.962.15 1.444.15 1.806 0 3.367-.598 4.681-1.792 1.315-1.195 2.057-2.674 2.229-4.438a.908.908 0 0 1 .236-.507.642.642 0 0 1 .49-.208.66.66 0 0 1 .497.208.616.616 0 0 1 .172.507c-.185 2.14-1.067 3.944-2.645 5.414-1.579 1.47-3.466 2.204-5.662 2.204a8.26 8.26 0 0 1-1.866-.211 8.658 8.658 0 0 1-1.778-.622 2.726 2.726 0 0 1-1.451.417Zm0-1.39a1.38 1.38 0 0 0 1.013-.416 1.38 1.38 0 0 0 .417-1.014c0-.397-.139-.735-.417-1.013a1.38 1.38 0 0 0-1.013-.417c-.398 0-.736.139-1.014.417a1.38 1.38 0 0 0-.417 1.013c0 .398.14.736.417 1.014a1.38 1.38 0 0 0 1.014.417ZM10 3.057c-1.806 0-3.367.597-4.681 1.791C4.004 6.042 3.262 7.521 3.09 9.285a.907.907 0 0 1-.236.507.642.642 0 0 1-.49.208.66.66 0 0 1-.497-.208.616.616 0 0 1-.173-.507C1.88 7.146 2.762 5.342 4.34 3.872c1.579-1.47 3.466-2.205 5.661-2.205.634 0 1.256.07 1.867.212a8.66 8.66 0 0 1 1.778.621 2.77 2.77 0 0 1 1.451-.403c.775 0 1.436.275 1.984.823.548.548.822 1.21.822 1.986a2.72 2.72 0 0 1-.823 1.99 2.7 2.7 0 0 1-1.986.826c-.776 0-1.439-.275-1.99-.825a2.715 2.715 0 0 1-.826-1.994 2.78 2.78 0 0 1 .555-1.674v.424a6.715 6.715 0 0 0-1.389-.448c-.481-.1-.963-.15-1.444-.15Zm5.097 3.277c.394 0 .728-.139 1.004-.417.275-.278.413-.616.413-1.013 0-.394-.138-.728-.413-1.004a1.365 1.365 0 0 0-1.004-.413c-.393 0-.73.138-1.01.413-.28.276-.42.61-.42 1.004 0 .393.139.73.417 1.01.278.28.616.42 1.013.42Z"
    />
    <path
      fill="black"
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
      opacity={0.2}
    />
    <path
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10.083 12.167a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z"
    />
  </svg>
)

export const IconFilterCustomers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#F5F2FF"
      fillRule="evenodd"
      d="M.25.823A.55.55 0 0 1 .75.5h9.5a.55.55 0 0 1 .414.912L7.3 5.257v6.293a.55.55 0 0 1-.894.43l-2.5-2a.55.55 0 0 1-.206-.43V5.257L.336 1.412a.55.55 0 0 1-.087-.59Zm1.712.777 2.702 3.088a.55.55 0 0 1 .136.362v4.236l1.4 1.12V5.05a.55.55 0 0 1 .136-.362L9.038 1.6H1.962Z"
      clipRule="evenodd"
    />
  </svg>
)

export const ArchiveIcon = ({ color = "black", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <path d="M1.50033 3.91981V10.2436C1.50033 10.3184 1.52435 10.3799 1.57241 10.4279C1.62046 10.476 1.68192 10.5 1.75678 10.5H10.2439C10.3187 10.5 10.3802 10.476 10.4282 10.4279C10.4763 10.3799 10.5003 10.3184 10.5003 10.2436V3.91981H1.50033ZM1.82095 11.5834C1.45109 11.5834 1.12463 11.4418 0.841576 11.1588C0.55852 10.8757 0.416992 10.5493 0.416992 10.1794V3.02565C0.416992 2.84731 0.450811 2.67717 0.51845 2.51523C0.58595 2.35342 0.68727 2.20412 0.822409 2.06731L2.07574 0.798145C2.21241 0.66134 2.35859 0.563562 2.51428 0.504812C2.66998 0.446062 2.83519 0.416687 3.00991 0.416687H8.9747C9.14942 0.416687 9.31595 0.446062 9.47428 0.504812C9.63262 0.563562 9.78019 0.66134 9.91699 0.798145L11.1782 2.08335C11.3134 2.22016 11.4147 2.37078 11.4822 2.53523C11.5498 2.69981 11.5837 2.87134 11.5837 3.04981V10.1794C11.5837 10.5493 11.4421 10.8757 11.1591 11.1588C10.876 11.4418 10.5496 11.5834 10.1797 11.5834H1.82095ZM1.61741 2.83669H10.3753L9.17491 1.58815C9.14824 1.56148 9.11755 1.54009 9.08283 1.52398C9.0481 1.50801 9.01206 1.50002 8.9747 1.50002H3.01803C2.98067 1.50002 2.94456 1.50801 2.9097 1.52398C2.87498 1.54009 2.84428 1.56148 2.81762 1.58815L1.61741 2.83669Z" fill={color}/>
    <path d="M5.63154 4.69855C5.73723 4.59605 5.86633 4.5448 6.01883 4.5448C6.17133 4.5448 6.29897 4.59605 6.40175 4.69855C6.50466 4.80105 6.55612 4.92834 6.55612 5.08042L6.55612 7.87813L7.55446 6.87959C7.67529 6.7589 7.80432 6.69855 7.94154 6.69855C8.07876 6.69855 8.20779 6.7589 8.32862 6.87959C8.44932 7.00043 8.51182 7.13077 8.51612 7.27063C8.52029 7.41063 8.46473 7.53834 8.34945 7.65376L6.47925 9.51105C6.34758 9.64786 6.1939 9.71626 6.0182 9.71626C5.84265 9.71626 5.68744 9.6489 5.55258 9.51418L3.67945 7.65376C3.55876 7.53292 3.49841 7.4039 3.49841 7.26667C3.49841 7.12945 3.55876 7.00042 3.67945 6.87959C3.80029 6.7589 3.93064 6.69987 4.0705 6.70251C4.2105 6.70529 4.33821 6.76431 4.45362 6.87959L5.47279 7.87813L5.47279 5.08042C5.47279 4.92834 5.5257 4.80105 5.63154 4.69855Z" fill={color}/>
  </svg>
)

export const ArchivedIconSelected = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <path d="M1.50033 3.91981V10.2436C1.50033 10.3184 1.52435 10.3799 1.57241 10.4279C1.62046 10.476 1.68192 10.5 1.75678 10.5H10.2439C10.3187 10.5 10.3802 10.476 10.4282 10.4279C10.4763 10.3799 10.5003 10.3184 10.5003 10.2436V3.91981H1.50033ZM1.82095 11.5834C1.45109 11.5834 1.12463 11.4418 0.841576 11.1588C0.55852 10.8757 0.416992 10.5493 0.416992 10.1794V3.02565C0.416992 2.84731 0.450811 2.67717 0.51845 2.51523C0.58595 2.35342 0.68727 2.20412 0.822409 2.06731L2.07574 0.798145C2.21241 0.66134 2.35859 0.563562 2.51428 0.504812C2.66998 0.446062 2.83519 0.416687 3.00991 0.416687H8.9747C9.14942 0.416687 9.31595 0.446062 9.47428 0.504812C9.63262 0.563562 9.78019 0.66134 9.91699 0.798145L11.1782 2.08335C11.3134 2.22016 11.4147 2.37078 11.4822 2.53523C11.5498 2.69981 11.5837 2.87134 11.5837 3.04981V10.1794C11.5837 10.5493 11.4421 10.8757 11.1591 11.1588C10.876 11.4418 10.5496 11.5834 10.1797 11.5834H1.82095ZM1.61741 2.83669H10.3753L9.17491 1.58815C9.14824 1.56148 9.11755 1.54009 9.08283 1.52398C9.0481 1.50801 9.01206 1.50002 8.9747 1.50002H3.01803C2.98067 1.50002 2.94456 1.50801 2.9097 1.52398C2.87498 1.54009 2.84428 1.56148 2.81762 1.58815L1.61741 2.83669Z"  fill="#5C5CEB"/>
    <path d="M5.63154 4.69855C5.73723 4.59605 5.86633 4.5448 6.01883 4.5448C6.17133 4.5448 6.29897 4.59605 6.40175 4.69855C6.50466 4.80105 6.55612 4.92834 6.55612 5.08042L6.55612 7.87813L7.55446 6.87959C7.67529 6.7589 7.80432 6.69855 7.94154 6.69855C8.07876 6.69855 8.20779 6.7589 8.32862 6.87959C8.44932 7.00043 8.51182 7.13077 8.51612 7.27063C8.52029 7.41063 8.46473 7.53834 8.34945 7.65376L6.47925 9.51105C6.34758 9.64786 6.1939 9.71626 6.0182 9.71626C5.84265 9.71626 5.68744 9.6489 5.55258 9.51418L3.67945 7.65376C3.55876 7.53292 3.49841 7.4039 3.49841 7.26667C3.49841 7.12945 3.55876 7.00042 3.67945 6.87959C3.80029 6.7589 3.93064 6.69987 4.0705 6.70251C4.2105 6.70529 4.33821 6.76431 4.45362 6.87959L5.47279 7.87813L5.47279 5.08042C5.47279 4.92834 5.5257 4.80105 5.63154 4.69855Z"  fill="#5C5CEB"/>
  </svg>
)

export const FlagIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || "#1C1B1F"}
      d="M2 7.808v4.234c0 .15-.054.277-.16.383a.522.522 0 0 1-.383.159.52.52 0 0 1-.382-.16.522.522 0 0 1-.159-.382V1.087c0-.186.065-.344.196-.474a.645.645 0 0 1 .474-.196h8.715a.62.62 0 0 1 .359.105c.102.07.186.156.25.257.065.102.091.214.079.338a.834.834 0 0 1-.125.359L9.043 4.113l1.821 2.636c.071.115.113.235.125.359a.517.517 0 0 1-.078.338.884.884 0 0 1-.251.257.62.62 0 0 1-.36.105H2Zm0-1.083h7.443L8.23 4.888a1.344 1.344 0 0 1-.238-.776c0-.286.08-.544.238-.775L9.443 1.5H2v5.225Z"
    />
  </svg>
)

export const ReleaseDateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || "#212529"}
      d="M2.257 13.583c-.375 0-.692-.132-.951-.396a1.301 1.301 0 0 1-.389-.944V3.756c0-.365.13-.68.389-.944.259-.264.576-.396.95-.396h1.821V.878A.543.543 0 0 1 4.631.32a.548.548 0 0 1 .562.558v1.538H7.84V.862A.527.527 0 0 1 8.377.32c.153 0 .282.052.388.156a.52.52 0 0 1 .158.386v1.554h1.82c.376 0 .693.132.952.396.26.264.389.579.389.944v8.487c0 .366-.13.68-.389.944a1.281 1.281 0 0 1-.951.396H2.257Zm0-1.083h8.487a.244.244 0 0 0 .176-.08.245.245 0 0 0 .08-.177V7.256H2v4.987c0 .064.027.123.08.176.054.054.113.08.177.08ZM2 6.173h9V3.756a.244.244 0 0 0-.08-.176.245.245 0 0 0-.176-.08H2.257a.245.245 0 0 0-.176.08.245.245 0 0 0-.08.176v2.417Z"
    />
  </svg>
)
export const IconHistory = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.98356 13.5833C5.22509 13.5833 3.72433 12.9957 2.48127 11.8204C1.23821 10.6453 0.547728 9.19818 0.409811 7.47915C0.392728 7.32749 0.437103 7.20304 0.542936 7.10582C0.648631 7.0086 0.777728 6.96263 0.930228 6.9679C1.0737 6.97332 1.19912 7.02089 1.30648 7.11061C1.41384 7.20033 1.47342 7.31839 1.48523 7.46478C1.62189 8.87714 2.21162 10.0694 3.2544 11.0417C4.29717 12.0139 5.54023 12.5 6.98356 12.5C8.49745 12.5 9.79259 11.9618 10.869 10.8854C11.9454 9.80902 12.4836 8.51388 12.4836 6.99999C12.4836 5.4861 11.9454 4.19096 10.869 3.11457C9.79259 2.03818 8.49745 1.49999 6.98356 1.49999C6.17051 1.49999 5.4178 1.65776 4.72544 1.97332C4.03294 2.28874 3.43467 2.72283 2.93064 3.27561H4.50606C4.65953 3.27561 4.78814 3.32714 4.89189 3.4302C4.99578 3.53325 5.04773 3.66089 5.04773 3.81311C5.04773 3.96547 4.99578 4.0945 4.89189 4.2002C4.78814 4.30603 4.65953 4.35895 4.50606 4.35895H1.48689C1.29703 4.35895 1.13794 4.29471 1.0096 4.16624C0.881131 4.0379 0.816895 3.87881 0.816895 3.68895V0.669779C0.816895 0.516307 0.868422 0.387696 0.971478 0.283946C1.07453 0.180057 1.20224 0.128113 1.3546 0.128113C1.50683 0.128113 1.63585 0.180057 1.74169 0.283946C1.84738 0.387696 1.90023 0.516307 1.90023 0.669779V2.85249C2.50703 2.10999 3.24745 1.51839 4.12148 1.0777C4.99537 0.637001 5.9494 0.416654 6.98356 0.416654C7.89745 0.416654 8.75342 0.589362 9.55148 0.934779C10.3497 1.2802 11.0457 1.74992 11.6396 2.34395C12.2336 2.93783 12.7034 3.63381 13.0488 4.43186C13.3942 5.22992 13.5669 6.08582 13.5669 6.99957C13.5669 7.91332 13.3942 8.76936 13.0488 9.5677C12.7034 10.366 12.2336 11.0621 11.6396 11.656C11.0457 12.2501 10.3497 12.7198 9.55148 13.0652C8.75342 13.4106 7.89745 13.5833 6.98356 13.5833ZM7.54919 6.4552L9.63252 8.53853C9.74794 8.65381 9.80349 8.77797 9.79919 8.91103C9.79502 9.04409 9.73252 9.17096 9.61169 9.29165C9.49099 9.41235 9.36203 9.4727 9.22481 9.4727C9.08745 9.4727 8.95842 9.41235 8.83773 9.29165L6.6771 7.13103C6.60905 7.06283 6.55683 6.98839 6.52044 6.9077C6.48419 6.827 6.46606 6.7436 6.46606 6.65749V3.53478C6.46606 3.38325 6.51898 3.25624 6.62481 3.15374C6.73078 3.05124 6.85849 2.99999 7.00794 2.99999C7.15724 2.99999 7.28481 3.05186 7.39065 3.15561C7.49634 3.2595 7.54919 3.38818 7.54919 3.54165V6.4552Z" fill="#1C1B1F"/>
  </svg>
);

export const CommitmentDateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill={"#5C5CEB"}
    {...props}
  >
    <path
      fill={props.fill || "#5C5CEB"}
      d="M6.382 5.25V3.086a.6.6 0 0 0-.176-.435.588.588 0 0 0-.438-.18.604.604 0 0 0-.44.177.593.593 0 0 0-.18.44v2.42c0 .087.016.169.05.245.035.076.08.143.138.2l1.698 1.699a.601.601 0 0 0 .875 0 .594.594 0 0 0 .189-.432.575.575 0 0 0-.189-.426L6.382 5.25Zm-1.595 4.941c.217-.457.54-.83.97-1.115a2.555 2.555 0 0 1 1.449-.429h2.059a4.456 4.456 0 0 0 1.03-2.882c0-1.262-.44-2.332-1.318-3.211-.878-.88-1.948-1.319-3.209-1.319-1.26 0-2.33.44-3.212 1.319-.88.879-1.32 1.949-1.32 3.21 0 1.087.337 2.04 1.012 2.857a4.487 4.487 0 0 0 2.539 1.57ZM7.206 14a2.561 2.561 0 0 1-1.87-.764 2.623 2.623 0 0 1-.807-1.844c-1.304-.286-2.384-.95-3.242-1.994C.429 8.355 0 7.142 0 5.758 0 4.16.56 2.802 1.681 1.68 2.802.561 4.163 0 5.765 0c1.601 0 2.962.56 4.083 1.681s1.681 2.482 1.681 4.084a5.79 5.79 0 0 1-.197 1.518 5.43 5.43 0 0 1-.575 1.364h.566c.744 0 1.376.26 1.896.78.52.521.781 1.153.781 1.896 0 .744-.26 1.376-.78 1.896-.521.52-1.153.781-1.897.781H7.206Zm0-1.235h4.117c.397 0 .736-.142 1.018-.425.283-.283.424-.623.424-1.02a1.38 1.38 0 0 0-.424-1.017 1.393 1.393 0 0 0-1.018-.42H7.206c-.396 0-.736.14-1.018.424a1.394 1.394 0 0 0-.423 1.02c0 .398.14.737.423 1.017.282.28.622.42 1.018.42Zm.003-.824a.606.606 0 0 1-.44-.176.588.588 0 0 1-.18-.438c0-.174.058-.32.176-.441a.588.588 0 0 1 .437-.18c.174 0 .321.059.441.176.12.118.18.264.18.438a.606.606 0 0 1-.176.441.588.588 0 0 1-.438.18Zm2.06 0a.606.606 0 0 1-.442-.176.588.588 0 0 1-.18-.438c0-.174.059-.32.177-.441a.588.588 0 0 1 .437-.18c.174 0 .321.059.441.176.12.118.18.264.18.438a.606.606 0 0 1-.176.441.588.588 0 0 1-.438.18Zm2.058 0a.606.606 0 0 1-.441-.176.588.588 0 0 1-.18-.438c0-.174.059-.32.176-.441a.588.588 0 0 1 .438-.18c.174 0 .32.059.441.176.12.118.18.264.18.438a.606.606 0 0 1-.176.441.588.588 0 0 1-.438.18Z"
    />
  </svg>
)
export const DuplicateIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.33958 14.4871C1.96458 14.4871 1.64757 14.3576 1.38854 14.0986C1.12951 13.8395 1 13.5225 1 13.1475V8.76606C1 8.61231 1.05139 8.48363 1.15417 8.38002C1.25708 8.27627 1.38479 8.2244 1.53729 8.2244C1.68979 8.2244 1.81889 8.27627 1.92458 8.38002C2.03042 8.48363 2.08333 8.61231 2.08333 8.76606V13.1475C2.08333 13.2116 2.11 13.2703 2.16333 13.3238C2.21681 13.3771 2.27556 13.4038 2.33958 13.4038H7.72104C7.87479 13.4038 8.00347 13.4552 8.10708 13.5581C8.21083 13.6609 8.26271 13.7886 8.26271 13.9411C8.26271 14.0936 8.21083 14.2227 8.10708 14.3286C8.00347 14.4343 7.87479 14.4871 7.72104 14.4871H2.33958ZM5.24354 11.5834C4.8684 11.5834 4.55132 11.4538 4.29229 11.1948C4.03326 10.9358 3.90375 10.6187 3.90375 10.2436V5.86232C3.90375 5.70857 3.95521 5.57981 4.05813 5.47606C4.1609 5.37245 4.28854 5.32065 4.44104 5.32065C4.59354 5.32065 4.72264 5.37245 4.82833 5.47606C4.93417 5.57981 4.98708 5.70857 4.98708 5.86232V10.2436C4.98708 10.3077 5.01382 10.3665 5.06729 10.4198C5.12063 10.4733 5.17938 10.5 5.24354 10.5H10.6248C10.7785 10.5 10.9073 10.5514 11.011 10.6542C11.1147 10.7571 11.1665 10.8848 11.1665 11.0373C11.1665 11.1898 11.1147 11.3189 11.011 11.4246C10.9073 11.5304 10.7785 11.5834 10.6248 11.5834H5.24354ZM8.14729 8.6794C7.77229 8.6794 7.45528 8.54988 7.19625 8.29086C6.93722 8.03183 6.80771 7.71481 6.80771 7.33981V2.85252C6.80771 2.47752 6.93722 2.16051 7.19625 1.90148C7.45528 1.64245 7.77229 1.51294 8.14729 1.51294H13.6346C14.0096 1.51294 14.3266 1.64245 14.5856 1.90148C14.8447 2.16051 14.9742 2.47752 14.9742 2.85252V7.33981C14.9742 7.71481 14.8447 8.03183 14.5856 8.29086C14.3266 8.54988 14.0096 8.6794 13.6346 8.6794H8.14729ZM8.14729 7.59627H13.6346C13.6986 7.59627 13.7574 7.56954 13.8108 7.51606C13.8642 7.46259 13.8908 7.40384 13.8908 7.33981V4.09627H7.89083V7.33981C7.89083 7.40384 7.91757 7.46259 7.97104 7.51606C8.02451 7.56954 8.08326 7.59627 8.14729 7.59627Z" fill="#585C68"/>
  </svg>
);

export const BagelChatIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={39} height={39} x={0.5} y={0.5} stroke="#EEEFF1" rx={5.5} />
    <path
      fill="#FF8700"
      fillRule="evenodd"
      d="M8 20c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12S8 26.627 8 20Zm12-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
      clipRule="evenodd"
    />
    <path
      fill="#5C5CEB"
      stroke="#fff"
      d="M29.102 7.51a.55.55 0 0 1 .443.469 5.217 5.217 0 0 0 4.477 4.475.551.551 0 0 1 0 1.092 5.218 5.218 0 0 0-4.477 4.476.55.55 0 0 1-1.09 0 5.217 5.217 0 0 0-4.476-4.476.551.551 0 0 1-.47-.444L23.5 13l.01-.102a.552.552 0 0 1 .468-.444 5.217 5.217 0 0 0 4.476-4.475A.551.551 0 0 1 29 7.5l.102.01Z"
    />
  </svg>
);

export const BagelAiSendButtonDisabled = ({ size = 30, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g opacity={0.15}>
      <rect width={30} height={30} fill="#597EFF" rx={4} />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M21 13.658 19.598 15 16 11.622V22h-2V11.622L10.402 15 9 13.658 15 8l6 5.658Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const BagelAiSendButtonActive = ({ size = 30, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <rect width={30} height={30} fill="#5C5CEB" rx={4} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M21 13.658 19.598 15 16 11.622V22h-2V11.622L10.402 15 9 13.658 15 8l6 5.658Z"
      clipRule="evenodd"
    />
  </svg>
);

export const StopAiIcon = ({ size = 30, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <rect width={30} height={30} fill="#5C5CEB" rx={4} />
    <path
      fill="#fff"
      d="M10.333 21c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 9 19.667v-9.334c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h9.334c.366 0 .68.13.941.392.261.26.392.575.392.941v9.334c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.941.392h-9.334Z"
    />
  </svg>
);

export const AiBadgeIcon = ({ size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    {...props}
  >
    <path
      fill="#5C5CEB"
      d="M1 9a.06.06 0 0 1 .053-.06A6.861 6.861 0 0 0 6.94 3.053.06.06 0 0 1 7 3a.06.06 0 0 1 .06.053 6.861 6.861 0 0 0 5.887 5.887A.06.06 0 0 1 13 9a.06.06 0 0 1-.053.06 6.861 6.861 0 0 0-5.888 5.887A.06.06 0 0 1 7 15a.06.06 0 0 1-.06-.053A6.86 6.86 0 0 0 1.054 9.06.06.06 0 0 1 1 9ZM10 3.4c0-.012.01-.022.021-.024a2.744 2.744 0 0 0 2.355-2.355A.024.024 0 0 1 12.4 1c.012 0 .022.01.024.021a2.744 2.744 0 0 0 2.355 2.355.024.024 0 0 1 .021.024c0 .012-.01.022-.021.024a2.744 2.744 0 0 0-2.355 2.355.024.024 0 0 1-.024.021.024.024 0 0 1-.024-.021 2.744 2.744 0 0 0-2.355-2.355A.024.024 0 0 1 10 3.4Z"
    />
  </svg>
);

export const ClariIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
    viewBox="0 0 45 39"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path d="M44.5468 7.40039L30.5879 11.1921C31.1526 13.811 31.4502 16.5877 31.4502 19.501C31.4502 22.4143 31.1503 25.1887 30.5879 27.8099L44.5468 31.6017C45.4396 27.8193 45.9082 23.6743 45.9082 19.5034C45.9082 15.3325 45.4396 11.1827 44.5468 7.40039Z" fill="#00D7B8"/>
      <path d="M9.20182 3.48193L0 19.4988L14.5631 8.57125C13.1665 6.47759 11.3482 4.75367 9.20182 3.48193Z" fill="#5F3AD7"/>
      <path d="M9.20182 35.5187L0 19.4995L14.5631 30.427C13.1665 32.5231 11.3482 34.247 9.20182 35.5187Z" fill="#5F3AD7"/>
      <path d="M25.9895 0L0 19.5006L30.5893 11.1917C29.6942 7.03482 28.1265 3.2713 25.9895 0Z" fill="#0280FF"/>
      <path d="M25.9895 38.9996L0 19.499L30.5893 27.808C29.6942 31.9672 28.1265 35.7307 25.9895 38.9996Z" fill="#0280FF"/>
      <path d="M31.454 19.4989C31.454 16.5856 31.1541 13.8112 30.5917 11.1899L0 19.4989L30.5893 27.8079C31.1564 25.1842 31.454 22.4169 31.454 19.4989Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="45" height="39" fill="white"/> 
      </clipPath>
    </defs>
  </svg>
)

export const StackFront = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.2}
    className="icon icon-tabler icons-tabler-outline icon-tabler-stack-front"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <path fill="currentColor" d="M12 4 4 8l8 4 8-4-8-4" />
    <path d="m8 14-4 2 8 4 8-4-4-2" />
    <path d="m8 10-4 2 8 4 8-4-4-2" />
  </svg>
)

export const SubFileTextIcon = (props) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_16316_5020)">
      <path d="M12.3086 5.56283L11.7205 8.07092C11.2165 10.237 10.2205 11.113 8.34844 10.933C8.04841 10.909 7.7244 10.855 7.37641 10.771L6.36836 10.531C3.86628 9.937 3.09226 8.70094 3.68027 6.19285L4.26829 3.67878C4.3883 3.16876 4.5323 2.72475 4.71231 2.35873C5.41433 0.906689 6.60836 0.516678 8.6124 0.990692L9.61445 1.2247C12.1286 1.81272 12.8965 3.05476 12.3086 5.56283Z" stroke="#5C5CEB" stroke-width="1.00803" stroke-linecap="round" stroke-linejoin="round"/>
      <path opacity="0.12" d="M8.34858 10.933C7.97654 11.185 7.50853 11.3951 6.93851 11.5811L5.99049 11.893C3.60841 12.6611 2.35437 12.019 1.58035 9.637L0.812324 7.26692C0.0442998 4.88485 0.680319 3.62481 3.06239 2.85678L4.01042 2.54478C4.25643 2.46677 4.49043 2.40077 4.71245 2.35876C4.53244 2.72478 4.38844 3.16879 4.26843 3.67881L3.68041 6.19288C3.0924 8.70097 3.86642 9.93703 6.3685 10.5311L7.37655 10.771C7.72454 10.8551 8.04855 10.9091 8.34858 10.933Z" fill="#5C5CEB"/>
      <path d="M8.34884 10.9331C7.9768 11.1851 7.50879 11.395 6.93876 11.5811L5.99073 11.8931C3.60866 12.6611 2.35462 12.0191 1.58059 9.63702L0.812566 7.26692C0.0445453 4.88485 0.680564 3.62481 3.06264 2.85678L4.01067 2.54478C4.25668 2.46677 4.49068 2.40077 4.71269 2.35876C4.53268 2.72478 4.38868 3.16879 4.26867 3.67881L3.68066 6.19288C3.09264 8.70099 3.86666 9.93698 6.36874 10.531L7.37681 10.7711C7.72479 10.855 8.0488 10.909 8.34884 10.9331Z" stroke="#5C5CEB" stroke-width="1.00803" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.89648 4.41687L9.8066 5.15489" stroke="#5C5CEB" stroke-width="1.00803" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.30835 6.73889L8.04841 7.1829" stroke="#5C5CEB" stroke-width="1.00803" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_16316_5020">
        <rect width="13" height="13" fill="white"/>
      </clipPath>
    </defs>
  </svg>

)

export const IdeaCopyIcon = (props) => (  
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.8158 5.99231L13.1624 8.77898C12.6024 11.1856 11.4958 12.159 9.41577 11.959C9.08244 11.9323 8.72244 11.8723 8.33577 11.779L7.21577 11.5123C4.43577 10.8523 3.57577 9.47898 4.2291 6.69231L4.88244 3.89898C5.01577 3.33231 5.17577 2.83898 5.37577 2.43231C6.15577 0.81898 7.48244 0.385647 9.7091 0.912313L10.8224 1.17231C13.6158 1.82565 14.4691 3.20565 13.8158 5.99231Z" stroke="#4B4BE8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path opacity="0.12" d="M9.4162 11.9589C9.00287 12.2389 8.48287 12.4722 7.84954 12.6789L6.7962 13.0256C4.14954 13.8789 2.7562 13.1656 1.8962 10.5189L1.04287 7.88558C0.189537 5.23892 0.896204 3.83892 3.54287 2.98558L4.5962 2.63892C4.86954 2.55225 5.12954 2.47892 5.3762 2.43225C5.1762 2.83892 5.0162 3.33225 4.88287 3.89892L4.22954 6.69225C3.5762 9.47892 4.4362 10.8523 7.2162 11.5122L8.3362 11.7789C8.72287 11.8723 9.08287 11.9323 9.4162 11.9589Z" fill="#4B4BE8"/>
    <path d="M9.4162 11.9589C9.00287 12.2389 8.48287 12.4723 7.84954 12.6789L6.7962 13.0256C4.14954 13.8789 2.7562 13.1656 1.8962 10.5189L1.04287 7.88558C0.189537 5.23892 0.896204 3.83892 3.54287 2.98558L4.5962 2.63892C4.86954 2.55225 5.12954 2.47892 5.3762 2.43225C5.1762 2.83892 5.0162 3.33225 4.88287 3.89892L4.22954 6.69225C3.5762 9.47892 4.4362 10.8523 7.2162 11.5123L8.3362 11.7789C8.72287 11.8723 9.08287 11.9323 9.4162 11.9589Z" stroke="#4B4BE8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.80273 4.71899L11.0361 5.53899" stroke="#4B4BE8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.14941 7.29895L9.08275 7.79228" stroke="#4B4BE8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)